import React, { useEffect, useState } from "react";
import { buildAppUrl } from "../../config/externalUrls";
import { Link, useNavigate } from "react-router-dom";
import DashBoardSidebar from "../../layouts/dashBoard-Sidebar";
import DashboardNavbar from "../../layouts/dashboardNavbar";
import { toast } from "react-toastify";
import {
  getEnrollmentAmount,
  UnEnroll,
  VerifyUser,
  deleteJointInfo,
  generateCert,
  generateCertRetake,
  generateCertSecond,
  generateCertSecondRetake,
  getCounty,
  getDistrict,
  getStates,
  getUserData,
  getUserRetakeData,
  resendCert,
  resendCertRetake,
  retakeCCCourse,
  retakeDECourse,
  updateProfile,
  uploadCert,
  uploadCertRetake,
  updateAdminAssociateAttorney,
  changePasswordByAdmin,
  UnEnrollRetake,
  resendCertToAttorney,
  resendCertRetakeToAttorney
} from "../../api/server";
import { useLocation } from "react-router-dom";
import { Field, useFormik } from "formik";
import * as Yup from "yup";
import { ThreeDots } from "react-loader-spinner";
import cross from "../../assets/images/SiteImg/cross.png";
import generateIcon from "../../assets/images/generateIcon.png";

import VerifyButton from "../Common/VerifyButton";
import AttorneyReferralStatus from "../Common/AttorneyReferralStatus";
import { MdWarning } from "react-icons/md";
import { FaCopy, FaEye } from "react-icons/fa";
import { FiUpload } from "react-icons/fi";
import "./editing-client.css";
import SetupBirthDatePicker from "./SetupBirthDatePicker";
const intialLoadingStates = {
  isCCVerifying: false,
  isDEVerifying: false,
  CCAssociating: false,
  DEAssociating: false
}

const FIRST_COURSE_TOTAL_CLASSES = 14;
const CLASS_ONE_COMPLETION_PERCENT = Math.floor(
  (1 / FIRST_COURSE_TOTAL_CLASSES) * 100
);
const hasCompletedClassOne = (progress) =>
  Number(progress || 0) >= CLASS_ONE_COMPLETION_PERCENT;

const EditingClient = () => {
  const [showJointFiler, setShowJointFiler] = useState(false);
  const [isInputClicked, setIsInputClicked] = useState(false);
  const [mainPasswordMessage, setMainPasswordMessage] = useState("");
  const [jointPasswordMessage, setJointPasswordMessage] = useState("");
  const [inCompleteUserInfo, setInCompleteUserInfo] = useState(false);


  // const validationSchema = Yup.object().shape({
  //   firstname: Yup.string().required("First Name is required"),
  //   lastname: Yup.string().required("Last Name is required"),
  //   ssn: Yup.string().required("Last Four Digits of SSN is required").matches(/^\d{4}$/, "SSN must be exactly 4 digits and only numbers are allowed"),
  //   phone: Yup.string().required("Phone Number is required"),
  //   password: Yup.string(),
  //   // .required("Password is required"),
  //   addr1: Yup.string().required("Address Line 1 is required"),
  //   addr2: Yup.string(),
  //   city: Yup.string().required("City is required"),
  //   state: Yup.string().required("State is required"),
  //   zip: Yup.string().required("Zip Code is required"),
  //   email: Yup.string().required("Your Email is required"),
  //   username: Yup.string().required("Username is required"),
  //   joint_firstname: Yup.string(),
  //   joint_lastname: Yup.string(),
  //   joint_ssn: showJointFiler && Yup.string().required("Last Four Digits of SSN is required").matches(/^\d{4}$/, "SSN must be exactly 4 digits and only numbers are allowed"),
  //   joint_phone: Yup.string(),
  //   joint_firstname: showJointFiler
  //     ? Yup.string().required("First name is required")
  //     : Yup.string(),
  //   joint_lastname: showJointFiler
  //     ? Yup.string().required("Last name is required")
  //     : Yup.string(),

  //   joint_username: showJointFiler
  //     ? Yup.string().required("Username is required")
  //     : Yup.string(),
  //   // joint_password: showJointFiler
  //   //   ? Yup.string().required("Password is required")
  //   //   : Yup.string(),
  //   takenByPhone: Yup.boolean(),
  // });

  const validationSchema = Yup.object().shape({
  });

  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const userId = queryParams.get("id");
  const cert = queryParams.get("cert");

  const [deleteJoint, setDeleteJoint] = useState(false);

  const [response, setResponse] = useState();
  const [enrollmentLoading, setEnrollmentLoading] = useState(false);
  const enrollmentLock = React.useRef(false);
  const startEnrollment = async (course) => {
    if (enrollmentLock.current) return;
    enrollmentLock.current = true;
    setEnrollmentLoading(true);
    try {
      const code = String(values[`couponcode_${course}`] || "").trim();
      let enrollmentQuote;
      const billing = values.billingoptions ?? response?.billingoptions;
      const needsPrice = code && values[`paid_${course}`] !== "checked" &&
        !(course === "first" && (values.google_add ?? response?.google_add) === "1") &&
        ["client", "", course === "first" ? "DE" : "CC"].includes(billing);
      if (needsPrice) {
        const result = await getEnrollmentAmount(code, "admin");
        const raw = result.data?.amount;
        const amount = Number(raw);
        if ((typeof raw !== "number" && typeof raw !== "string") || String(raw).trim() === "" || !Number.isFinite(amount) || amount < 0) {
          throw new Error("Invalid course amount");
        }
        enrollmentQuote = { studentId: userId, course, code, amount };
      }
      navigate(`/enroll-user-${course}-course?id=${userId}`, { state: { enrollmentQuote } });
    } catch (error) {
      toast.error("Unable to load the latest course price. Please try again.");
    } finally {
      enrollmentLock.current = false;
      setEnrollmentLoading(false);
    }
  };
  const [courseData, setCourseData] = useState();
  const [retakecourseData, setRetakeCourseData] = useState();
  const [secEmails, setSecEmails] = useState([]);
  const [getloading, setGetLoading] = useState(true);
  const [postLoading, setPostLoading] = useState(false);
  const [cancelEnrollLoader, setCancelEnrollLoader] = useState(false);
  const [cancelEnrollLoaderFirst, setCancelEnrollLoaderFirst] = useState(false);
  const [cancelRetakeEnrollLoader, setCancelRetakeEnrollLoader] = useState(false);


  const [statesData, setStatesData] = useState([]);

  const [selectedStateFirst, setSelectedStateFirst] = useState("");
  const [selectedStateSecond, setSelectedStateSecond] = useState("");

  const [selectedCountyFirst, setSelectedCountyFirst] = useState("");
  const [selectedCountySecond, setSelectedCountySecond] = useState("");

  const [countiesDataFirst, setCountiesDataFirst] = useState([]);
  const [countiesDataSecond, setCountiesDataSecond] = useState([]);

  const [districtsDataFirst, setDistrictsDataFirst] = useState([]);
  const [districtsDataSecond, setDistrictsDataSecond] = useState([]);

  const [oldcode, setOldcode] = useState("");

  const [firstPDF, setFirstPDF] = useState();
  const [firstPDFJoint, setFirstPDFJoint] = useState();

  const [uploadingFirst, setUploadingFirst] = useState(false);
  const [uploadingFirstJoint, setUploadingFirstJoint] = useState(false);

  const [secondPDF, setSecondPDF] = useState();
  const [secondPDFJoint, setSecondPDFJoint] = useState();

  const [uploadingSecond, setUploadingSecond] = useState(false);
  const [uploadingSecondJoint, setUploadingSecondJoint] = useState(false);

  const [generatingFirst, setGeneratingFirst] = useState(false);
  const [generatingFirstJoint, setGeneratingFirstJoint] = useState(false);

  const [generatingSecond, setGeneratingSecond] = useState(false);
  const [generatingSecondJoint, setGeneratingSecondJoint] = useState(false);

  const [firstPDFRetake, setFirstPDFRetake] = useState();
  const [firstPDFJointRetake, setFirstPDFJointRetake] = useState();

  const [uploadingFirstRetake, setUploadingFirstRetake] = useState(false);
  const [uploadingFirstJointRetake, setUploadingFirstJointRetake] = useState(false);

  const [secondPDFRetake, setSecondPDFRetake] = useState();
  const [secondPDFJointRetake, setSecondPDFJointRetake] = useState();

  const [uploadingSecondRetake, setUploadingSecondRetake] = useState(false);
  const [uploadingSecondJointRetake, setUploadingSecondJointRetake] = useState(false);

  const [generatingFirstRetake, setGeneratingFirstRetake] = useState(false);
  const [generatingFirstJointRetake, setGeneratingFirstJointRetake] = useState(false);

  const [generatingSecondRetake, setGeneratingSecondRetake] = useState(false);
  const [generatingSecondJointRetake, setGeneratingSecondJointRetake] = useState(false);

  const [resendingFirstRetakeToUser, setResendingFirstRetakeToUser] = useState(false);
  const [resendingFirstRetakeToAttorney, setResendingFirstRetakeToAttorney] = useState(false);

  const [resendingFirstJointRetakeToUser, setResendingFirstJointRetakeToUser] = useState(false)
  const [resendingFirstJointRetakeToAttorney, setResendingFirstJointRetakeToAttorney] = useState(false);
  ;
  

  const [resendingSecondRetake, setResendingSecondRetake] = useState(false);
  const [resendingSecondJointRetake, setResendingSecondJointRetake] = useState(false);

  const [loading, setLoading] = useState(false);
  const [loadingStates, setLoadingStates] = useState(intialLoadingStates)
  const [attCodeValidation, setattCodeValidation] = useState(false);
  const [passwordUpdating, setPasswordUpdating] = useState(false)

  const [showPass, setShowPass] = useState(false);
  const [showAttymPass, setShowAttymPass] = useState(false);

  const [resendingFirstToUser, setResendingFirstToUser] = useState(false);
  const [resendingFirstToAttorney, setResendingFirstAttorney] = useState(false);

  const [resendingFirstJointToUser, setResendingFirstJointToUser] = useState(false);
  const [resendingFirstJointToAttorney, setResendingFirstJointToAttorney] = useState(false);


  const [reTakingCC, setReTakingCC] = useState(false);
  const [reTakingDE, setReTakingDE] = useState(false);

  // [allow associate]
  const [allowAssociate, setAllowAssociate] = useState({
    CC: true,
    DE: true
  })

  const [resendingSecondToUser, setResendingSecondToUser] = useState(false);
  const [resendingSecondToAttorney, setResendingSecondToAttorney] = useState(false);

  const [resendingSecondJointToUser, setResendingSecondJointToUser] = useState(false);
  const [resendingSecondJointToAttorney, setResendingSecondJointToAttorney] = useState(false);
  const [cancelEnrollData, setCancelEnrollData] = useState({
    id: "",
    cource: "",
  });
  const [cancelRetakeEnrollData, setCancelRetakeEnrollData] = useState({
    id: "",
    cource: "",
  });
  const [isModal, setIsModal] = useState(false);

  const [copied, setCopied] = useState(false);
  const [copiedSecond, setCopiedSecond] = useState(false);
  const [attorneyNote, setAttorneyNote] = useState("")
  const [isRetakeModal, setIsRetakeModal] = useState(false);


  const handleCopy = () => {

    let linkToCopy = `${buildAppUrl("beforecontactwithcounselor")}?id=${response?.id}&course=first`;

    navigator.clipboard.writeText(linkToCopy);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleCopysecond = () => {
    let linkToCopy = `${buildAppUrl("beforecontactwithcounselor")}?id=${response?.id}&course=second`;
    navigator.clipboard.writeText(linkToCopy);
    setCopiedSecond(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleUnEnroll = async (setValues, values) => {
    const data = {
      id: cancelEnrollData.id,
      course: cancelEnrollData.cource,
    };
    console.log("value === ", cancelEnrollData.cource === "first", data);
    try {
      if (cancelEnrollData.cource === "first") {
        setCancelEnrollLoaderFirst(true);
      } else {
        setCancelEnrollLoader(true);
      }

      const response = await UnEnroll(data);
      if (response) {
        // console.log("responseresponse??????",response)
        if (cancelEnrollData.cource === "first") {
          setValues({
            ...values,
            courseFirstEnrol: false,
            paid_first: response?.data?.paid_first
          });
        } else {
          setValues({
            ...values,
            courseSecondEnrol: false,
            paid_second: response?.data?.paid_second
          });
        }
        setCancelEnrollLoader(false);
        setCancelEnrollLoaderFirst(false);
        toast.success("Cancel Enrollment successfully");
      }
      setIsModal(false);
      setCancelEnrollData({
        id: "",
        cource: "",
      });
    } catch (error) {
      setCancelEnrollLoader(false);
      setCancelEnrollLoaderFirst(false);
      setIsModal(false);
      toast.error(error.response.data.error);
      console.error("Error:", error);
      setCancelEnrollData({
        id: "",
        cource: "",
      });
    }
  };

  const handleUnEnrollRetakeFirst = async (setValues, values) => {
    const data = {
      id: cancelRetakeEnrollData.id,
      course: cancelRetakeEnrollData.cource,
    };
    // console.log("Cancel Retake (First) === ", data);

    try {
      setCancelRetakeEnrollLoader(true);


      const response = await UnEnrollRetake(data);

      if (response) {
        setValues({
          ...values,
          course_first_retake: "0",
        });

        toast.success("First course retake enrollment cancelled successfully");
      }

      setIsRetakeModal(false);
      setCancelRetakeEnrollData({ id: "", cource: "" });
    } catch (error) {
      toast.error(error?.response?.data?.error || "Failed to cancel first course retake");
      console.error("Cancel Retake First Error:", error);

      setIsRetakeModal(false);
      setCancelRetakeEnrollData({ id: "", cource: "" });
    } finally {
      setCancelRetakeEnrollLoader(false);
    }
  };

  const {
    handleChange,
    touched,
    values,
    setValues,
    errors,
    handleSubmit,
    handleBlur,
    resetForm,
  } = useFormik({
    initialValues: { response },
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm, setValues }) => {
      if (
        values.couponcode_first &&
        oldcode !== values.couponcode_first &&
        values.attorneyCodeExist
      ) {
        toast.error("Please verify attorney code.");
      } else {
        setPostLoading(true);
        updateProfile(userId, values)
          .then((res) => {
            fetchData(true);
            fetchRetakeData(true);
            if (values.couponcode_first == "") {
              setSecEmails([]);
            }
          })
          .catch((err) => {
            toast.error(err.response.data.error);
            setPostLoading(false);
          });
      }
    },
  });
  console.log("-----values ===> ", values)
  const generateCertificate = (values, isJoint) => {
    // const payload = {...values , count:certificateCounts}
    generateCert(userId, values, isJoint ? "true" : "false")
      .then((res) => {
        toast.success(res.data.message);
        setGeneratingFirst(false);
        setGeneratingFirstJoint(false);
        let data = { ...courseData };

        if (values.course == "first") {
          if (res.data.mainLink) {
            data = {
              ...data,
              courseFirstGenerated: "yes",
              courseFirstDownloaded: res.data.mainLink,
              courseFirstDate: res.data.date,
            };
          }
          if (res.data.jointLink) {
            data = {
              ...data,
              jointCourseFirstGenerated: "yes",
              jointCourseFirstDownloaded: res.data.jointLink,
              jointCourseFirstDate: res.data.date,
            };
          }
          setCourseData({
            ...data,
          });
        }
        //  if(res.data.count){
        //   setCertificateCounts(res.data.count)
        // }
      })
      .catch((err) => {
        toast.error(err.response.data.error);
        setGeneratingFirst(false);
        setGeneratingFirstJoint(false);
      });
  };

  const resendCertificate = (values, setLoading) => {
    resendCert(values)
      .then((res) => {
        toast.success(res.data.message);
        setLoading(false);
      })
      .catch((err) => {
        toast.error(err.response.data.error);
        setLoading(false);
      });
  };

  const buildAttorneyResendPayload = ({
    firstName,
    lastName,
    link,
    attyEmail,
    course,
    type,
  }) => ({
    firstName,
    lastName,
    link,
    attyEmail,
    secondaryEmail: secEmails,
    userid: userId,
    course,
    type,
  });

    const resendCertificateToAttorney = (values, setLoading) => {
      if(values?.attyEmail || values?.secondaryEmail.length > 0){
        const secondaryEmailList = Array.isArray(values.secondaryEmail)
        ? values.secondaryEmail.map((item) => item.email)
        : [];

      // Replace old structure with string-only email array
      const updatedValues = {
        ...values,
        secondaryEmail: secondaryEmailList,
      };

       resendCertToAttorney(updatedValues)
      .then((res) => {
        toast.success(res.data.message);
        setLoading(false);
      })
      .catch((err) => {
        toast.error(err.response.data.error);
        setLoading(false);
      });
      }
      else{
         toast.error("Attorney email is required to resend certificate to attorney.")
         setLoading(false)
      }
   
  };

  const generateCertificateSecond = (values) => {
    // const payload = {...values , count:certificateCounts}
    generateCertSecond(userId, values)
      .then((res) => {
        toast.success(res.data.message);
        setCourseData({
          ...courseData,
          jointCourseSecondGenerated: "yes",
          jointCourseSecondDownloaded: res.data.link2,
          jointCourseSecondDate: res.data.date,
          generated: "yes",
          downloaded: res.data.link1,
          date: res.data.date,
        });
        // if(res.data.count){
        //   setCertificateCounts(res.data.count)
        // }
        if (values.sendEmail) {
          navigate(
            `/certificate-to-court?id=${userId}&court=${res.data.courtLink}`
          );
        }

        setGeneratingSecond(false);
        setGeneratingSecondJoint(false);
      })
      .catch((err) => {
        toast.error(err.response.data.error);
        setGeneratingSecond(false);
        setGeneratingSecondJoint(false);
      });
  };

  const uploadCertificate = async (course, values, isJoint) => {
    const data = new FormData();
    data.append("courseId", values.courseId);
    data.append("course", values.course);
    data.append("email", values.email);
    data.append("attyemail", values.attyemail);
    data.append("file", values.file);
    data.append("retake", 0);
    // data.append("count", JSON.stringify(certificateCounts)); 

    return uploadCert(userId, data, isJoint ? "true" : "false")
      .then((res) => {
        toast.success(res.data.message);
        setUploadingFirst(false);
        setUploadingFirstJoint(false);
        if (course == "first") {
          if (isJoint) {
            setFirstPDFJoint("")
            setCourseData({
              ...courseData,
              jointCourseFirstGenerated: "yes",
              jointCourseFirstDownloaded: res.data.link,
              jointCourseFirstDate: res.data.date,
            });
          } else {
            setFirstPDF("")
            setCourseData({
              ...courseData,
              courseFirstGenerated: "yes",
              courseFirstDownloaded: res.data.link,
              courseFirstDate: res.data.date,
            });
          }
        } else {
          if (isJoint) {
            setSecondPDFJoint("")
            setCourseData({
              ...courseData,
              jointCourseSecondGenerated: "yes",
              jointCourseSecondDownloaded: res.data.link,
              jointCourseSecondDate: res.data.date,
            });
          } else {
            setSecondPDF("")
            setCourseData({
              ...courseData,
              generated: "yes",
              downloaded: res.data.link,
              date: res.data.date,
            });
          }
        }
        // if(res.data.count){
        //   setCertificateCounts(res.data.count)
        // }
        setUploadingSecond(false);
        setUploadingSecondJoint(false);
      })
      .catch((err) => {
        toast.error(err.response.data.error);
        setUploadingFirst(false);
        setUploadingSecond(false);
        setUploadingFirstJoint(false);
        setUploadingSecondJoint(false);
      })
      ;
  };

  const reTakeCC = () => {
    retakeCCCourse(userId)
      .then((res) => {
        toast.success(res.data.message);
        setReTakingCC(false);
        window.location.reload();
      })
      .catch((err) => {
        toast.error(err.response.data.error);
        setReTakingCC(false);
      });
  };

  const reTakeDE = () => {
    retakeDECourse(userId)
      .then((res) => {
        toast.success(res.data.message);
        setReTakingDE(false);
        window.location.reload();
      })
      .catch((err) => {
        toast.error(err.response.data.error);
        setReTakingDE(false);
      });
  };

  const generateCertificateRetake = (values, isJoint) => {
    // const payload = {...values , count: retakeCertificateCounts}
    generateCertRetake(userId, values, isJoint ? "true" : "false")
      .then((res) => {
        toast.success(res.data.message);
        setGeneratingFirstRetake(false);
        setGeneratingFirstJointRetake(false);
        let data = { ...retakecourseData };

        if (values.course == "first") {
          if (res.data.mainLink) {
            data = {
              ...data,
              courseFirstGenerated: "yes",
              courseFirstDownloaded: res.data.mainLink,
              courseFirstDate: res.data.date,
            };
          }
          if (res.data.jointLink) {
            data = {
              ...data,
              jointCourseFirstGenerated: "yes",
              jointCourseFirstDownloaded: res.data.jointLink,
              jointCourseFirstDate: res.data.date,
            };
          }
          console.log(data, res);

          setRetakeCourseData({
            ...data,
          });
        }
        // if(res.data.count){
        //   setRetakeCertificateCounts(res.data.count)
        // }
      })
      .catch((err) => {
        toast.error(err.response.data.error);
        setGeneratingFirstRetake(false);
        setGeneratingFirstJointRetake(false);
      });
  };

  const resendCertificateRetake = (values, setLoading) => {
    resendCertRetake(values)
      .then((res) => {
        toast.success(res.data.message);
        setLoading(false);
      })
      .catch((err) => {
        toast.error(err.response.data.error);
        setLoading(false);
      });
  };
  const resendCertificateRetakeToAttorney = (values, setLoading) => {
    if(values?.attyEmail || values?.secondaryEmail.length > 0){
      const secondaryEmailList = Array.isArray(values.secondaryEmail)
    ? values.secondaryEmail.map((item) => item.email)
    : [];

  // Replace old structure with string-only email array
  const updatedValues = {
    ...values,
    secondaryEmail: secondaryEmailList,
  };

       resendCertRetakeToAttorney(updatedValues)
      .then((res) => {
        toast.success(res.data.message);
        setLoading(false);
      })
      .catch((err) => {
        toast.error(err.response.data.error);
        setLoading(false);
      });
    }
    else{
      toast.error("Attorney email is required to resend certificate to attorney.")
          setLoading(false)
    }
   
  };

  const generateCertificateSecondRetake = (values) => {
    generateCertSecondRetake(userId, values)
      .then((res) => {
        toast.success(res.data.message);
        setRetakeCourseData({
          ...retakecourseData,
          jointCourseSecondGenerated: "yes",
          jointCourseSecondDownloaded: res.data.link2,
          jointCourseSecondDate: res.data.date,
          generated: "yes",
          downloaded: res.data.link1,
          date: res.data.date,
        });
        if (values.sendEmail) {
          navigate(
            `/certificate-to-court?id=${userId}&court=${res.data.courtLink}`
          );
        }
        setGeneratingSecondRetake(false);
        setGeneratingSecondJointRetake(false);
      })
      .catch((err) => {
        toast.error(err.response.data.error);
        setGeneratingSecondRetake(false);
        setGeneratingSecondJointRetake(false);
      });
  };

  const uploadCertificateRetake = (course, values, isJoint) => {
    const data = new FormData();
    data.append("courseId", values.courseId);
    data.append("course", values.course);
    data.append("email", values.email);
    data.append("attyemail", values.attyemail);
    data.append("file", values.file);
    data.append("retake", 1);
    // data.append("count", JSON.stringify(retakeCertificateCounts));

    uploadCertRetake(userId, data, isJoint ? "true" : "false")
      .then((res) => {
        toast.success(res.data.message);
        setUploadingFirstRetake(false);
        setUploadingFirstJointRetake(false);
        if (course == "first") {
          if (isJoint) {
            setFirstPDFJointRetake("")
            setRetakeCourseData({
              ...retakecourseData,
              jointCourseFirstGenerated: "yes",
              jointCourseFirstDownloaded: res.data.link,
              jointCourseFirstDate: res.data.date,
            });
          } else {
            setFirstPDFRetake("")
            setRetakeCourseData({
              ...retakecourseData,
              courseFirstGenerated: "yes",
              courseFirstDownloaded: res.data.link,
              courseFirstDate: res.data.date,
            });
          }
        } else {
          if (isJoint) {
            setRetakeCourseData({
              ...retakecourseData,
              jointCourseSecondGenerated: "yes",
              jointCourseSecondDownloaded: res.data.link,
              jointCourseSecondDate: res.data.date,
            });
          } else {
            setRetakeCourseData({
              ...retakecourseData,
              generated: "yes",
              downloaded: res.data.link,
              date: res.data.date,
            });
          }
        }
        // if(res.data.count){
        //   setRetakeCertificateCounts(res.data.count)
        // }
        setUploadingSecondRetake(false);
        setUploadingSecondJointRetake(false);
      })
      .catch((err) => {
        toast.error(err.response.data.error);
        setUploadingFirstRetake(false);
        setUploadingSecondRetake(false);
        setUploadingFirstJointRetake(false);
        setUploadingSecondJointRetake(false);
      });
  };

  const fetchData = async (show = false, fromDeleteJoint = false) => {
    await getUserData(userId)
      .then((res) => {
        if (show) {
          toast.success("User updated successfully");
          setPostLoading(false);
        }
        // setCertificateCounts(res.data.data.count)
        setCourseData(res.data.data.fetchStudent);
        setOldcode(res.data.data.user.couponcode_first);
        // console.log("res.data.data.user",res.data.data.user)
        setInCompleteUserInfo(res.data.data.inCompleteUserInfo)
        const response_value_body = {
          ...res.data.data.user,
          deliveryMethod: "E-mail",
          // takenByPhone:res.data.data.user.takenByPhone === "true",
          firstPhone: res.data.data.fetchStudent.firstPhone,
          secondPhone: res.data.data.fetchStudent.secondPhone,
          activeCode: res.data.data.activeCode,
          password: res.data.data.fetchStudent.password,
          joint_password: res.data.data.fetchStudent.joint_password,
          dob: res.data.data.fetchStudent.dob ? res.data.data.fetchStudent.dob.split("T")[0] : "",
        }
        setAttorneyNote(res.data.data.attorneyNote)
        setMainPasswordMessage(res.data.data.fetchStudent.mainPasswordMessage)
        setJointPasswordMessage(res.data.data.fetchStudent.jointPasswordMessage)

        setResponse(response_value_body);
        setValues(response_value_body);
        setSecEmails(res.data.data.secEmails);
        
        if (res.data.data.user.joint_username !== "") {
          setShowJointFiler(true);
        }
        setSelectedStateFirst(res.data.data.user.judicialdistrict_state_first);
        setSelectedCountyFirst(
          res.data.data.user.judicialdistrict_county_first
        );
        setSelectedCountySecond(
          res.data.data.user.judicialdistrict_county_second
        );
        setSelectedStateSecond(
          res.data.data.user.judicialdistrict_state_second
        );
        setGetLoading(false);
        if (fromDeleteJoint) {
          setShowJointFiler(false);
          setDeleteJoint(false);
        }
      })
      .catch((err) => {
        toast.error(err.response.data.error);
        setGetLoading(false);
        setDeleteJoint(false);
      });
    try {
      const response = await getStates();
      const data = response.data;
      setStatesData(data);
    } catch (error) {
      console.error("Error fetching states data:", error);
    }
  };
  const fetchRetakeData = async (show = false, fromDeleteJoint = false) => {
    await getUserRetakeData(userId)
      .then((res) => {
        setRetakeCourseData(res.data.data.fetchStudent);
        setGetLoading(false);
        if (fromDeleteJoint) {
          setShowJointFiler(false);
          setDeleteJoint(false);
        }
        // if(res.data.data.Count){
        //   setRetakeCertificateCounts(res.data.data.Count)
        // }
      })
      .catch((err) => {
        toast.error(err.response.data.error);
        setGetLoading(false);
        setDeleteJoint(false);
      });
  };
  useEffect(() => {
    fetchRetakeData();
    fetchData();
  }, []);

  useEffect(() => {
    setCountiesDataFirst([]);
    const fetchData = async () => {
      try {
        if (selectedStateFirst) {
          const response = await getCounty({ state: selectedStateFirst });
          const countiesData = response.data;
          setCountiesDataFirst(countiesData);
        }
      } catch (error) { }
    };

    fetchData();
  }, [selectedStateFirst]);

  useEffect(() => {
    setCountiesDataSecond([]);

    const fetchData = async () => {
      try {
        if (selectedStateSecond) {
          const response = await getCounty({ state: selectedStateSecond });
          const countiesData = response.data;
          setCountiesDataSecond(countiesData);
        }
      } catch (error) { }
    };

    fetchData();
  }, [selectedStateSecond]);

  useEffect(() => {
    setDistrictsDataFirst([]);
    const fetchData = async () => {
      try {
        if (selectedCountyFirst) {
          const districtResponse = await getDistrict({
            state: selectedStateFirst,
            county: selectedCountyFirst,
          });
          const distData = districtResponse.data;

          setDistrictsDataFirst(distData);
        }
      } catch (error) { }
    };

    fetchData();
  }, [selectedCountyFirst]);

  useEffect(() => {
    setDistrictsDataSecond([]);
    const fetchData = async () => {
      try {
        if (selectedCountySecond) {
          const districtResponse = await getDistrict({
            state: selectedStateSecond,
            county: selectedCountySecond,
          });
          const distData = districtResponse.data;

          setDistrictsDataSecond(distData);
        }
      } catch (error) { }
    };

    fetchData();
  }, [selectedCountySecond]);

  const handleVerifyAttorney = async (code, setValues, course) => {
    setattCodeValidation(false);
    // e.preventDefault();
    const body = {
      code: code,
    };
    try {
      setLoadingStates(prev => (
        { ...prev, isCCVerifying: course === "CC", isDEVerifying: course === "DE" }
      ))
      const response = await VerifyUser(body);
      if (response.status === 200) {
        const data = response.data;
        setOldcode(code);
        const payStatus =
          response.data.data.deliverymethod == "bill" ? "checked" : "";
        setSecEmails(response.data.secEmails);
        setValues((prev) => ({
          ...prev,
          // couponcode_first: course==="CC"? code:prev.couponcode_first,
          // couponcode_second: course==="DE"? code:prev.couponcode_second,
          attyemail: data.data.email,
          attorneyname: data.data.firstname,
          attorneyCodeExist: true,
          attyphone: data.data.phone,
          // paid_first: prev.courseFirstEnrol ? prev.paid_first : payStatus,
          // paid_second: prev.courseSecondEnrol ? prev.paid_second : payStatus,
        }));

        if (course === "DE") setLoadingStates(prev => ({ ...prev, isDEVerifying: false }))
        else setLoadingStates(prev => ({ ...prev, isCCVerifying: false }))
        toast.success("Attorney code verified!");
      } else {
        setattCodeValidation(course);
      }
    } catch (error) {
      setattCodeValidation(course);
      console.error("Error fetching states data:", error);
      setLoadingStates(intialLoadingStates);
    }
  };

  const deleteJointFiler = () => {
    setDeleteJoint(true);
    deleteJointInfo(userId)
      .then((res) => {
        fetchData(true, true);
        fetchRetakeData(true, true);
      })
      .catch((err) => {
        toast.error(err.response.data.error);
        setDeleteJoint(false);
      });
  };
  const changePasswordHandler = async () => {
    if (passwordUpdating) return;
    if (!values?.password || values?.password?.length < 1) return toast.error("Password cannot be empty!")
    setPasswordUpdating(true)
    try {
      const body = {
        id: userId,
        password: values.password,
        isJoint: false
      }
      console.log("------- body", body, values.password)
      const response = await changePasswordByAdmin(body)
      if (response.status === 200) {
        toast.success("Passowrd updated successfully!")
      }
    }
    catch (error) {
      toast.error(error.response.data.error)
      setPasswordUpdating(false)
    }

    finally {
      setPasswordUpdating(false)
    }
  }


  // course can be CC || DE
  const handleAssociateAttorney = async (course) => {
    console.log("🚀 ~ handleAssociateAttorney ~ course:", course)
    if (loadingStates.CCAssociating || loadingStates.DEAssociating) return;
    try {
      setLoadingStates(prev => ({ ...prev, CCAssociating: course === "CC", DEAssociating: course === "DE" }))
      const body = {
        id: userId,
        course,
        couponcode_first: values.couponcode_first,
        couponcode_second: values.couponcode_second,
        paid_first: values.paid_first,
        paid_second: values.paid_second,
        attyemail: values.attyemail,
        attorneyname: values.attorneyname,
        attyphone: values.attyphone,
        courseFirstEnrol: values.courseFirstEnrol,
        courseSecondEnroll: values.courseSecondEnrol

      }
      console.log("🚀 ~ handleAssociateAttorney ~ body:", body)
      const response = await updateAdminAssociateAttorney(body)
      if (response.status === 200) {
        toast.success(`${course} course associated successfully!`)
        setResponse(prev => ({ ...prev, paid_first: response.data.paid_first, paid_second: response.data.paid_second }))
        setValues((prev) => ({ ...prev, activeCode: course, paid_first: response.data.paid_first, paid_second: response.data.paid_second }))
      }
      setLoadingStates(intialLoadingStates)

    } catch (error) {
      console.log("🚀 ~ handleAssociateAttorney ~ error:", error)
      toast.error(error.response.data.error)
      setLoadingStates(intialLoadingStates)
    }

  }

  return (
    <div>
      <div className="wrapper">
        <DashBoardSidebar />
        {/* <!-- Page Content Holder --> */}
        <div id="content">
          <DashboardNavbar />
          {getloading || !response ? (
            <p>
              <ThreeDots
                height="40"
                width="80"
                radius="9"
                color="#4fa94d"
                ariaLabel="three-dots-loading"
                wrapperStyle={{
                  display: "flex",
                  justifyContent: "center",
                }}
                wrapperClassName="spinner"
                visible={true}
              />
            </p>
          ) : (
            values && (
              <section className="client-editing admin-student-edit">
                {!response?.judicialdistrict_first &&
                  response?.courseFirstEnrol &&
                  courseData?.courseFirstGenerated == "" &&
                  courseData.perFirstCourseMain == "100" && (
                    <div
                      className="text-box text_box_sec"
                      style={{
                        marginBottom: "2%",
                        padding: "15px",
                        backgroundColor: "#FFA500", // Orange (Warning)
                        color: "#FFFFFF",
                        fontWeight: "bold",
                        borderRadius: "5px",
                        textAlign: "center",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "8px",
                        position: "relative",
                        minHeight: "60px",
                        maxHeight: "60px",
                      }}
                    >
                      <MdWarning size={24} />
                      <h5 style={{ marginBottom: "0", flex: 1 }}>
                        Missing information for Course One. Share the link to
                        complete it.
                      </h5>
                      <div
                        style={{
                          position: "relative",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <button
                          onClick={handleCopy}
                          style={{
                            backgroundColor: "#fff",
                            color: "#FFA500",
                            border: "none",
                            padding: "8px 12px",
                            borderRadius: "5px",
                            fontWeight: "bold",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                            position: "relative", // Keep button position intact
                          }}
                        >
                          <FaCopy /> Copy Link
                        </button>
                        {copied && (
                          <span
                            style={{
                              position: "absolute",
                              top: "-25px",
                              left: "50%",
                              transform: "translateX(-50%)",
                              backgroundColor: "#000",
                              color: "#fff",
                              padding: "4px 8px",
                              borderRadius: "4px",
                              fontSize: "12px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Link Copied!
                          </span>
                        )}
                      </div>
                    </div>
                  )}
                {console.log(
                  "response<><><><><",
                  courseData,
                  courseData?.perFirstCourseMain
                )}
                {!response?.judicialdistrict_second &&
                  response?.courseSecondEnrol &&
                  courseData?.generated == "" &&
                  courseData.perSecondCourseMain == "100" && (
                    <div
                      className="text-box text_box_sec"
                      style={{
                        marginBottom: "5%",
                        padding: "15px",
                        backgroundColor: "#FFA500",
                        color: "#FFFFFF",
                        fontWeight: "bold",
                        borderRadius: "5px",
                        textAlign: "center",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "8px",
                        position: "relative",
                        minHeight: "60px",
                        maxHeight: "60px",
                      }}
                    >
                      <MdWarning size={24} />
                      <h5 style={{ marginBottom: "0", flex: 1 }}>
                        Missing information for Course Two. Share the link to
                        complete it.
                      </h5>
                      <div
                        style={{
                          position: "relative",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <button
                          onClick={handleCopysecond}
                          style={{
                            backgroundColor: "#fff",
                            color: "#FFA500",
                            border: "none",
                            padding: "8px 12px",
                            borderRadius: "5px",
                            fontWeight: "bold",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                            position: "relative", // Keep button position intact
                          }}
                        >
                          <FaCopy /> Copy Link
                        </button>
                        {copiedSecond && (
                          <span
                            style={{
                              position: "absolute",
                              top: "-25px",
                              left: "50%",
                              transform: "translateX(-50%)",
                              backgroundColor: "#000",
                              color: "#fff",
                              padding: "4px 8px",
                              borderRadius: "4px",
                              fontSize: "12px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Link Copied!
                          </span>
                        )}
                      </div>
                    </div>
                  )}
                {attorneyNote && (
                  <div
                    className="text-box text_box_sec"
                    style={{
                      marginBottom: "2%",
                      padding: "15px",
                      backgroundColor: "#f44336",
                      color: "#FFFFFF",
                      fontWeight: "500",
                      borderRadius: "5px",
                      textAlign: "left",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      border: "1px solid #ffeeba",
                      minHeight: "60px",
                      maxHeight: "auto",
                    }}
                  >
                    <MdWarning
                      size={24}
                      style={{ flexShrink: 0, marginTop: "2px" }}
                    />
                    <div style={{ flex: 1 }}>
                      <h5
                        style={{
                          margin: 0,
                          fontSize: "16px",
                          lineHeight: "1.4",
                        }}
                      >
                        Special Note: {attorneyNote}
                      </h5>
                    </div>
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="col-lg-12">
                    <div className="input_wrap">
                      <label className="label-title">Notes</label>
                      <textarea
                        name="notes"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.notes}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row ">
                    <div className="client-head">
                      <div className="row align-items-center">
                        <div className="col-lg-12">
                          <h1>Account Details</h1>
                        </div>
                      </div>
                    </div>

                    {/* <div className="client-head">
                    <h1>Account Details</h1>
                  </div> */}
                    <div className="row">
                      <div className="col-lg-6">
                        <div className=" input_wrap ">
                          <label className="label-title">
                            Bankruptcy Case No.
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="12-34567"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="bankruptcycasenum"
                            value={values.bankruptcycasenum}
                          />
                          {errors.bankruptcycasenum &&
                          touched.bankruptcycasenum ? (
                            <p className="text-danger">
                              {errors.bankruptcycasenum}
                            </p>
                          ) : null}

                          <div></div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className=" input_wrap ">
                          <label className="label-title">Attorney Name</label>
                          <input
                            type="text"
                            readOnly
                            className="form-control"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="attorneyname"
                            value={values.attorneyname}
                          />
                          {errors.attorneyname && touched.attorneyname ? (
                            <p className="text-danger">{errors.attorneyname}</p>
                          ) : null}
                        </div>
                      </div>

                      {response.courseFirstEnrol && (
                        <div className="col-lg-6">
                          <div className="col-lg-12 mb-4 fw-bold">
                            <h5 style={{ fontSize: "18px", fontWeight: "600" }}>
                              Judicial District(First Course)
                            </h5>
                          </div>
                          <div className="col-lg-12">
                            <div className=" input_wrap ">
                              <label className="label-title">State</label>
                              <select
                                value={values.judicialdistrict_state_first}
                                onChange={(e) => {
                                  setSelectedStateFirst(e.target.value);
                                  setSelectedCountyFirst("");
                                  setValues({
                                    ...values,
                                    judicialdistrict_state_first:
                                      e.target.value,
                                    judicialdistrict_county_first: "",
                                    judicialdistrict_first: "",
                                  });
                                }}
                                className="form-control"
                              >
                                {statesData.length > 0 && (
                                  <option value="">Select a State</option>
                                )}

                                {statesData.length > 0 ? (
                                  statesData.map((state, index) => (
                                    <option key={index} value={state.state}>
                                      {state.state}
                                    </option>
                                  ))
                                ) : (
                                  <option value="">Loading...</option>
                                )}
                              </select>
                              {errors.judicialdistrict_state_first &&
                              touched.judicialdistrict_state_first ? (
                                <p className="text-danger">
                                  {errors.judicialdistrict_state_first}
                                </p>
                              ) : null}
                            </div>
                          </div>
                          {selectedStateFirst && (
                            <div className="row">
                              <div className="col-lg-6">
                                <div className=" input_wrap ">
                                  <select
                                    className="form-control"
                                    value={values.judicialdistrict_county_first}
                                    onChange={(e) => {
                                      setSelectedCountyFirst(e.target.value);
                                      setValues({
                                        ...values,
                                        judicialdistrict_county_first:
                                          e.target.value,
                                      });
                                    }}
                                  >
                                    {countiesDataFirst.length > 0 && (
                                      <option value="">Select a county</option>
                                    )}
                                    {/* {values.judicialdistrict_county === "" && (
                                <option value="">Select a county</option>
                              )} */}
                                    {countiesDataFirst.length > 0 ? (
                                      countiesDataFirst.map((county, index) => (
                                        <option
                                          key={index}
                                          value={county.county}
                                        >
                                          {county.county}
                                        </option>
                                      ))
                                    ) : (
                                      <option value="">Loading...</option>
                                    )}
                                  </select>
                                  {errors.judicialdistrict_county_first &&
                                  touched.judicialdistrict_county_first ? (
                                    <p className="text-danger">
                                      {errors.judicialdistrict_county_first}
                                    </p>
                                  ) : null}
                                </div>
                              </div>
                              {selectedCountyFirst && (
                                <div className="col-lg-6">
                                  <div className=" input_wrap ">
                                    <select
                                      className="form-control"
                                      value={values.judicialdistrict_first}
                                      onChange={(e) => {
                                        setValues({
                                          ...values,
                                          judicialdistrict_first:
                                            e.target.value,
                                        });
                                      }}
                                    >
                                      {districtsDataFirst.length > 0 && (
                                        <option value="">
                                          Select a Judicial District
                                        </option>
                                      )}
                                      {/* {values.judicialdistrict === "" && (
                                <option value="">
                                  Select a Judicial District
                                </option>
                              )} */}
                                      {districtsDataFirst.length > 0 ? (
                                        districtsDataFirst.map(
                                          (district, index) => (
                                            <option
                                              key={index}
                                              value={district.subdistrict}
                                            >
                                              {district.subdistrict}
                                            </option>
                                          )
                                        )
                                      ) : (
                                        <option value="">Loading...</option>
                                      )}
                                    </select>
                                    {errors.judicialdistrict_first &&
                                    touched.judicialdistrict_first ? (
                                      <p className="text-danger">
                                        {errors.judicialdistrict_first}
                                      </p>
                                    ) : null}
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      )}
                      {response.courseSecondEnrol && (
                        <div className="col-lg-6">
                          <div className="col-lg-12 mb-4 fw-bold">
                            <h5 style={{ fontSize: "18px", fontWeight: "600" }}>
                              Judicial District(Second Course)
                            </h5>
                          </div>
                          <div className="col-lg-12">
                            <div className=" input_wrap ">
                              <label className="label-title">State</label>
                              <select
                                value={selectedStateSecond}
                                onChange={(e) => {
                                  setSelectedStateSecond(e.target.value);
                                  setSelectedCountySecond("");
                                  setValues({
                                    ...values,
                                    judicialdistrict_state_second:
                                      e.target.value,
                                    judicialdistrict_county_second: "",
                                    judicialdistrict_second: "",
                                  });
                                }}
                                className="form-control"
                              >
                                {statesData.length > 0 && (
                                  <option value="">Select a State</option>
                                )}

                                {statesData.length > 0 ? (
                                  statesData.map((state, index) => (
                                    <option key={index} value={state.state}>
                                      {state.state}
                                    </option>
                                  ))
                                ) : (
                                  <option value="">Loading...</option>
                                )}
                              </select>
                              {errors.judicialdistrict_state_second &&
                              touched.judicialdistrict_state_second ? (
                                <p className="text-danger">
                                  {errors.judicialdistrict_state_second}
                                </p>
                              ) : null}
                            </div>
                          </div>
                          {selectedStateSecond && (
                            <div className="row">
                              <div className="col-lg-6">
                                <div className=" input_wrap ">
                                  <select
                                    className="form-control"
                                    value={
                                      values.judicialdistrict_county_second
                                    }
                                    onChange={(e) => {
                                      setSelectedCountySecond(e.target.value);
                                      setValues({
                                        ...values,
                                        judicialdistrict_county_second:
                                          e.target.value,
                                      });
                                    }}
                                  >
                                    {countiesDataSecond.length > 0 && (
                                      <option value="">Select a county</option>
                                    )}
                                    {/* {values.judicialdistrict_county === "" && (
                                <option value="">Select a county</option>
                              )} */}
                                    {countiesDataSecond.length > 0 ? (
                                      countiesDataSecond.map(
                                        (county, index) => (
                                          <option
                                            key={index}
                                            value={county.county}
                                          >
                                            {county.county}
                                          </option>
                                        )
                                      )
                                    ) : (
                                      <option value="">Loading...</option>
                                    )}
                                  </select>
                                  {errors.judicialdistrict_county_second &&
                                  touched.judicialdistrict_county_second ? (
                                    <p className="text-danger">
                                      {errors.judicialdistrict_county_second}
                                    </p>
                                  ) : null}
                                </div>
                              </div>
                              {selectedCountySecond && (
                                <div className="col-lg-6">
                                  <div className=" input_wrap ">
                                    <select
                                      className="form-control"
                                      value={values.judicialdistrict_second}
                                      onChange={(e) => {
                                        setValues({
                                          ...values,
                                          judicialdistrict_second:
                                            e.target.value,
                                        });
                                      }}
                                    >
                                      {districtsDataSecond.length > 0 && (
                                        <option value="">
                                          Select a Judicial District
                                        </option>
                                      )}
                                      {/* {values.judicialdistrict === "" && (
                                <option value="">
                                  Select a Judicial District
                                </option>
                              )} */}
                                      {districtsDataSecond.length > 0 ? (
                                        districtsDataSecond.map(
                                          (district, index) => (
                                            <option
                                              key={index}
                                              value={district.subdistrict}
                                            >
                                              {district.subdistrict}
                                            </option>
                                          )
                                        )
                                      ) : (
                                        <option value="">Loading...</option>
                                      )}
                                    </select>
                                    {errors.judicialdistrict_second &&
                                    touched.judicialdistrict_second ? (
                                      <p className="text-danger">
                                        {errors.judicialdistrict_second}
                                      </p>
                                    ) : null}
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="row ">
                    <div className="client-head">
                      <div className="row align-items-center">
                        <div className="col-lg-12">
                          <h1>Personal Info...</h1>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-6">
                        <div className=" input_wrap ">
                          <label className="label-title">First Name</label>
                          <input
                            type="text"
                            className="form-control"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="firstname"
                            value={values.firstname}
                          />
                          {errors.firstname && touched.firstname ? (
                            <p className="text-danger">{errors.firstname}</p>
                          ) : null}

                          <div></div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className=" input_wrap ">
                          <label className="label-title">Middle Initial</label>
                          <input
                            type="text"
                            className="form-control"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="middleinitial"
                            value={values.middleinitial}
                          />
                          {errors.middleinitial && touched.middleinitial ? (
                            <p className="text-danger">
                              {errors.middleinitial}
                            </p>
                          ) : null}

                          <div></div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className=" input_wrap ">
                          <label className="label-title">Last Name</label>
                          <input
                            type="text"
                            className="form-control"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="lastname"
                            value={values.lastname}
                          />
                          {errors.lastname && touched.lastname ? (
                            <p className="text-danger">{errors.lastname}</p>
                          ) : null}

                          <div></div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className=" input_wrap ">
                          <label className="label-title">Last 4 SSN</label>
                          <input
                            type="text"
                            className="form-control"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="ssn"
                            value={values.ssn}
                          />
                          {errors.ssn && touched.ssn ? (
                            <p className="text-danger">{errors.ssn}</p>
                          ) : null}

                          <div></div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className=" input_wrap ">
                          <label className="label-title">Phone No.</label>
                          <input
                            type="text"
                            className="form-control"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="phone"
                            value={values.phone}
                          />
                          {errors.phone && touched.phone ? (
                            <p className="text-danger">{errors.phone}</p>
                          ) : null}

                          <div></div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className=" input_wrap ">
                          <label className="label-title">Email</label>
                          <input
                            type="text"
                            className="form-control"
                            name="email"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.email}
                          />
                          {errors.email && touched.email ? (
                            <p className="text-danger">{errors.email}</p>
                          ) : null}

                          <div></div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            gap: "12px",
                          }}
                          className=" input_wrap flex justify-between"
                        >
                          <div
                            style={{
                              flexGrow: 1,
                            }}
                          >
                            <label className="label-title">Password</label>
                            <div
                              style={{
                                position: "relative",
                                width: "100%",
                              }}
                              className="flex gap-2 items-center "
                            >
                              <input
                                type={showPass ? "text" : "password"}
                                className="relative form-control"
                                name="password"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.password}
                                onFocus={() => setIsInputClicked(true)}
                              />

                              {showPass ? (
                                <i
                                  className="fa fa-eye position-absolute cursor-pointer pt-lg-1"
                                  style={{ top: "20px", right: "10px" }}
                                  onClick={() => {
                                    setShowPass(false);
                                  }}
                                  aria-hidden="true"
                                ></i>
                              ) : (
                                <i
                                  className="fa fa-eye-slash position-absolute cursor-pointer pt-lg-1"
                                  style={{ top: "20px", right: "10px" }}
                                  onClick={() => {
                                    setShowPass(true);
                                  }}
                                  aria-hidden="true"
                                ></i>
                              )}
                            </div>
                            {errors.password && touched.password ? (
                              <p className="text-danger">{errors.password}</p>
                            ) : null}

                            {mainPasswordMessage && (
                              <p
                                style={{
                                  marginTop: "4px",
                                  fontSize: "14px",
                                  color: "green",
                                }}
                              >
                                {mainPasswordMessage}
                              </p>
                            )}
                          </div>
                          <div style={{ paddingTop: "2%" }}>
                            <button
                              type="button"
                              disabled={
                                values.password.length < 1 ||
                                !values.password ||
                                !isInputClicked ||
                                passwordUpdating
                              }
                              onClick={changePasswordHandler}
                              style={{ alignItems: "center" }}
                              className="btn_brnd"
                            >
                              {passwordUpdating ? (
                                <ThreeDots
                                  height="20"
                                  width="148"
                                  radius="9"
                                  color="#4fa94d"
                                  ariaLabel="three-dots-loading"
                                  wrapperStyle={{
                                    display: "block",
                                  }}
                                  wrapperClassName="spinner"
                                  visible={true}
                                />
                              ) : (
                                "Change Password"
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className=" input_wrap ">
                          <label className="label-title">User Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="username"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.username}
                          />
                          {errors.username && touched.username ? (
                            <p className="text-danger">{errors.username}</p>
                          ) : null}
                          <div></div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className=" input_wrap ">
                          <label className="label-title">
                            Mother Maiden Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.mother_maiden}
                            name="mother_maiden"
                          />
                          {errors.mother_maiden && touched.mother_maiden ? (
                            <p className="text-danger">
                              {errors.mother_maiden}
                            </p>
                          ) : null}
                          <div></div>
                        </div>
                      </div>
                        <div className="col-lg-6">
                          <div className="input_wrap">
                            <label className="label-title" htmlFor="edit-student-dob">Date of Birth</label>
                            <SetupBirthDatePicker
                              allowTyping
                              id="edit-student-dob"
                              dateFormat="yyyy-mm-dd"
                              className="client-date-picker"
                              menuClassName="client-date-picker-menu"
                              value={values.dob}
                              onChange={(value) => handleChange({ target: { name: "dob", value } })}
                              onBlur={handleBlur}
                            />
                              {errors.dob && touched.dob ? (
                            <p className="text-danger">
                              {errors.dob}
                            </p>
                          ) : null}
                          </div>
                        </div>
                      {/* <div className="iagree_radio mb-3">
                      <div>
                        <input
                          type="checkbox"
                          onChange={() => {
                            setValues({
                              ...values,
                              takenByPhone: !values.takenByPhone,
                            });
                          }}
                          onBlur={handleBlur}
                          checked={values.takenByPhone}
                          id="courseTaken"
                          className=" "
                        />
                        <label for="courseTaken">Taken by phone</label>
                      </div>
                    </div> */}

                      <div className="col-lg-12">
                        <div
                          className="iagree_radio mb-3"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            flexWrap: "wrap",
                            gap: "30px",
                          }}
                        >
                          <div className=" language" style={{ width: "17%" }}>
                            <div
                              className=" input_wrap "
                              style={{ marginBottom: "10px" }}
                            >
                              <label
                                className="label-title"
                                style={{ border: "none", boxShadow: "none" }}
                              >
                                Language
                              </label>
                              <select
                                value={values.language || "1"}
                                onChange={(e) => {
                                  setValues({
                                    ...values,
                                    language: e.target.value,
                                  });
                                }}
                                className="form-control"
                              >
                                <option value="1">English</option>
                                <option value="2">Spanish</option>
                              </select>

                              {errors.language && touched.language ? (
                                <p className="text-danger">{errors.language}</p>
                              ) : null}
                            </div>
                          </div>
                          <div>
                            <input
                              type="checkbox"
                              name="tickbox"
                              id="joint"
                              className=" "
                              checked={showJointFiler}
                              onChange={(e) => {
                                setShowJointFiler(e.target.checked);
                              }}
                            />
                            <label htmlFor="joint">Joint </label>
                          </div>
                          <div
                            className="credit-report-admin-status"
                          >
                            <input
                              type="checkbox"
                              id="credit_report"
                              checked={values.credit_report === "checked"}
                              readOnly
                              disabled
                            />
                            <label htmlFor="credit_report">Credit Report</label>
                          </div>
                        </div>

                        {/* conditional rendering */}
                      </div>
                    </div>
                  </div>

                  {showJointFiler && (
                    <div className="row mt-4">
                      <div className="client-head">
                        <div className="row align-items-center">
                          <div className="col-lg-12 d-flex justify-content-between align-items-center">
                            <h1 className="f18">Joint Filer Info</h1>
                            {values.joint_username && (
                              <button
                                type="button"
                                disabled={deleteJoint}
                                className="btn_brnd"
                                onClick={deleteJointFiler}
                              >
                                {deleteJoint ? (
                                  <ThreeDots
                                    height="20"
                                    width="135"
                                    radius="9"
                                    color="#4fa94d"
                                    ariaLabel="three-dots-loading"
                                    wrapperStyle={{
                                      display: "block",
                                    }}
                                    wrapperClassName="spinner"
                                    visible={true}
                                  />
                                ) : (
                                  "Delete Joint Filer"
                                )}
                              </button>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="row ">
                        <div className="col-lg-4 col-md-6">
                          <div className="input_wrap">
                            <label className="label-title">First Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="joint_firstname"
                              placeholder="Enter your first name"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.joint_firstname}
                            />
                            {errors.joint_firstname &&
                            touched.joint_firstname ? (
                              <p className="text-danger">
                                {errors.joint_firstname}
                              </p>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="input_wrap">
                            <label className="label-title">
                              Middle Initial
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="joint_middleinitial"
                              placeholder="Enter your middle name"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.joint_middleinitial}
                            />
                            {errors.joint_middleinitial &&
                            touched.joint_middleinitial ? (
                              <p className="text-danger">
                                {errors.joint_middleinitial}
                              </p>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="input_wrap">
                            <label className="label-title">Last Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="joint_lastname"
                              placeholder="Enter your last name"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.joint_lastname}
                            />
                            {errors.joint_lastname && touched.joint_lastname ? (
                              <p className="text-danger">
                                {errors.joint_lastname}
                              </p>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="input_wrap">
                            <label className="label-title">
                              Last Four Digits of SSN
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="joint_ssn"
                              placeholder="Enter digit of SSN"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.joint_ssn}
                            />
                            {errors.joint_ssn && touched.joint_ssn ? (
                              <p className="text-danger">{errors.joint_ssn}</p>
                            ) : null}
                          </div>
                        </div>
                        {/* <div className="col-lg-4 col-md-6">
                              <div className="input_wrap">
                                <label className="label-title">
                                  Phone Number
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="joint_phone"
                                  placeholder="Enter your phone no."
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.joint_phone}
                                />
                                {errors.joint_phone && touched.joint_phone ? (
                                  <p className="text-danger">
                                    {errors.joint_phone}
                                  </p>
                                ) : null}
                              </div>
                            </div> */}
                        <div className="col-lg-4 col-md-6">
                          <div className="input_wrap">
                            <label className="label-title">
                              Joint Filer's Username
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="joint_username"
                              placeholder="Enter your username"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.joint_username}
                            />
                            {errors.joint_username && touched.joint_username ? (
                              <p className="text-danger">
                                {errors.joint_username}
                              </p>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="input_wrap">
                            <label className="label-title">
                              Joint Filer's Password
                            </label>
                            <input
                              type={showAttymPass ? "text" : "password"}
                              className="form-control"
                              name="joint_password"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values?.joint_password}
                            />
                            {showAttymPass ? (
                              <i
                                className="fa fa-eye position-absolute cursor-pointer pt-lg-1"
                                style={{ top: "20px", right: "10px" }}
                                onClick={() => {
                                  setShowAttymPass(false);
                                }}
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i
                                className="fa fa-eye-slash position-absolute cursor-pointer pt-lg-1"
                                style={{ top: "20px", right: "10px" }}
                                onClick={() => {
                                  setShowAttymPass(true);
                                }}
                                aria-hidden="true"
                              ></i>
                            )}
                            {errors.joint_password && touched.joint_password ? (
                              <p className="text-danger">
                                {errors.joint_password}
                              </p>
                            ) : null}
                            {jointPasswordMessage && (
                              <p
                                style={{
                                  marginTop: "4px",
                                  fontSize: "14px",
                                  color: "green",
                                }}
                              >
                                {jointPasswordMessage}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="row">
                    <div className="client-head">
                      <div className="row align-items-center">
                        <div className="col-lg-12">
                          <h1>Completed courses</h1>
                        </div>
                      </div>
                    </div>

                    <div
                      className="completed-course-section"
                      style={{ display: "flex", gap: "30px" }}
                    >
                      <div
                        className="col-lg-6"
                        style={{
                          border: "1px solid #D4D6D7",
                          borderRadius: "24px",
                          padding: "25px 35px",
                        }}
                      >
                        <div
                          className="row"
                          //   style={{
                          //   border: '1px solid #D4D6D7',
                          //   borderRadius: '24px',
                          //   padding: '25px 35px'
                          // }}
                        >
                          <div
                            className="client-head"
                            style={{
                              backgroundColor: "transparent",
                              marginBottom: "20px",
                              padding: "10px 0px",
                              // marginTop: "-30px",
                            }}
                          >
                            <div className="row align-items-center">
                              <div className="col-lg-12">
                                <div class="row">
                                  <div class="col-lg-5">
                                    <h1>Credit Counseling</h1>
                                  </div>
                                  {values.courseFirstEnrol && (
                                    <div
                                      class="col-lg-7"
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-around",
                                      }}
                                    >
                                      {/* <div className="btn_wrap text-center">
                                      <span
                                        // type="button"
                                        // className="btn_brnd"
                                        disabled={cancelEnrollLoaderFirst}
                                        // style={{ padding: "10px 18px" }}
                                          style={{
                                  color: "#4e9c4b",
                                  fontSize: "16px",
                                  fontWeight: "600",
                                  textDecorationLine: "underline",
                                  width: "40%",
                                }}
                                        onClick={() => {
                                          setCancelEnrollData({
                                            // value:'first',
                                            id: values.id,
                                            cource: "first",
                                          });
                                          setIsModal(true);
                                          // handleUnEnroll(values.id,"first",setValues,values)
                                        }}
                                      >
                                        Cancel Enrollment
                                      </span>
                                    </div> */}
                                      {values.courseFirstEnrol && (
                                        // <div className="mt-4 mb-4 flex">
                                        <>
                                          {(hasCompletedClassOne(
                                            courseData?.perFirstCourseMain
                                          ) ||
                                            hasCompletedClassOne(
                                              courseData?.perFirstCourseJoint
                                            )) && (
                                            <Link
                                              to={`/budget-analysis-report?id=${userId}`}
                                              style={{
                                                color: "#4e9c4b",
                                                fontSize: "16px",
                                                fontWeight: "600",
                                                textDecorationLine: "underline",
                                              }}
                                            >
                                              Budget Analysis
                                            </Link>
                                          )}

                                          <Link
                                            to={`/courseprogress?id=${userId}&course=first`}
                                            // className="ms-4"
                                            style={{
                                              color: "#4e9c4b",
                                              fontSize: "16px",
                                              fontWeight: "600",
                                              textDecorationLine: "underline",
                                              // width: "40%",
                                            }}
                                          >
                                            {/* <button type="button" className="btn_brnd">
                                  Course Progress
                                </button> */}
                                            Course Progress
                                          </Link>
                                        </>
                                        // </div>
                                      )}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* {values.courseFirstEnrol && values.payment_first && (
                       <div className="mb-5 mt-3" style={{ marginTop: '1rem', marginBottom: '1rem',display:'flex', alignItems:'center',gap:'10px'}}>
                       <h5 style={{ fontWeight: "600", fontSize: "17px" }}>
                         Payment Mode:
                       </h5>
                     
                       <div style={{ 
                         display: 'inline-block',
                         backgroundColor: '#e5f3ea',
                         color: '#166534',
                         padding: '10px 16px',
                         borderRadius: '8px',
                         fontWeight: '600',
                         fontSize: '15px',
                         boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
                       }}>
                         {(values.payment_first === "bill" || values.payment_first === "CC")
                           ? "Paid By Attorney"
                           : values.payment_first === "Admin manually checked"
                             ? "Payment status manually updated by admin."
                             : values.payment_first === "Google Add" ?
                             "Google Ad"
                             : "Credit Card"}
                       </div>
                     </div>
                         )} */}
                          <div className="iagree_radio ">
                            <div className="d-flex gap-4">
                              <div className="w-20">
                                <div className="iagree_radio">
                                  <div>
                                    <input
                                      type="checkbox"
                                      name="tickbox"
                                      checked={values.paid_first === "checked"}
                                      onChange={(e) => {
                                        setValues({
                                          ...values,
                                          paid_first: e.target.checked
                                            ? "checked"
                                            : "",
                                        });
                                      }}
                                      id="paid_first"
                                      className=" "
                                    />
                                    <label for="paid_first">Paid </label>
                                  </div>
                                  {errors.start && touched.start ? (
                                    <p className="text-danger">
                                      {errors.start}
                                    </p>
                                  ) : null}
                                </div>
                              </div>
                              {values.courseFirstEnrol && (
                                <div className="w-30">
                                  <div className="iagree_radio">
                                    <div>
                                      <input
                                        type="checkbox"
                                        onChange={() => {
                                          setValues({
                                            ...values,
                                            firstPhone:
                                              values.firstPhone == 1 ? 0 : 1,
                                          });
                                        }}
                                        onBlur={handleBlur}
                                        checked={values.firstPhone == 1}
                                        id="firstPhone"
                                        className=""
                                      />
                                      <label for="firstPhone">Phone</label>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>

                            {values.courseFirstEnrol ? (
                              <></>
                            ) : (
                              // <div className="mt-4 mb-4 flex">
                              //   <Link to={
                              //     inCompleteUserInfo
                              //             ? `/beforecontactwithcounselor?id=${userId}&course=first`
                              //             : `/user-first-course?id=${userId}`
                              //     // `/user-first-course?id=${userId}`
                              //     }>
                              //     <button className="btn_brnd">
                              //       Continue Course
                              //     </button>
                              //   </Link>
                              //   <Link
                              //     to={`/courseprogress?id=${userId}&course=first`}
                              //     className="ms-4"
                              //   >
                              //     <button type="button" className="btn_brnd">
                              //       Course Progress
                              //     </button>
                              //   </Link>
                              // </div>
                              <div className="mt-4 mb-4 ">
                                <button type="button" className="btn_brnd" disabled={enrollmentLoading} onClick={() => startEnrollment("first")}>
                                    {enrollmentLoading ? "Loading..." : "Enroll Now"}
                                  </button>
                              </div>
                            )}
                          </div>

                          <div
                            className="col-lg-12 "
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "20px",
                              marginTop: "2.5rem",
                            }}
                          >
                            {values.courseFirstEnrol && (
                              // <div className="col-lg-12 fw-bold">
                              <h5
                                style={{
                                  fontWeight: "600",
                                  fontSize: "17px",
                                  marginBottom: "0",
                                }}
                              >
                                Main Filer
                                <span style={{ fontSize: "14px" }}>
                                  {" "}
                                  ({courseData.perFirstCourseMain.toFixed(0)}%
                                  Completed)
                                </span>
                              </h5>
                              // </div>
                            )}

                            {values.courseFirstEnrol &&
                              courseData?.courseFirstGenerated == "" && (
                                <button
                                  type="button"
                                  className="view-certificate-btn mb-2"
                                  onClick={() => {
                                    if (values.judicialdistrict_first) {
                                      setGeneratingFirst(true);

                                      if (
                                        response.judicialdistrict_first !==
                                        values.judicialdistrict_first
                                      ) {
                                        setPostLoading(true);
                                        updateProfile(userId, values)
                                          .then((res) => {
                                            toast.success(
                                              "User updated successfully"
                                            );
                                            setPostLoading(false);
                                            generateCertificate(
                                              {
                                                courseMainId:
                                                  courseData.courseFirstId,
                                                courseJointId:
                                                  courseData.jointCourseFirstId,
                                                main: true,
                                                joint:
                                                  courseData?.perFirstCourseJoint ===
                                                  100,
                                                course: "first",
                                                email:
                                                  response.deliverymethod ==
                                                  "E-mail"
                                                    ? response.email
                                                    : "",
                                                attyemail: response.attypref
                                                  ? response.attyemail
                                                  : "",
                                              },
                                              false
                                            );
                                          })
                                          .catch((err) => {
                                            toast.error(
                                              err.response.data.error
                                            );
                                            setPostLoading(false);
                                          });
                                      } else {
                                        generateCertificate(
                                          {
                                            courseMainId:
                                              courseData.courseFirstId,
                                            courseJointId:
                                              courseData.jointCourseFirstId,
                                            course: "first",
                                            main: true,
                                            joint:
                                              courseData?.perFirstCourseJoint ===
                                              100,
                                            email:
                                              response.deliverymethod ==
                                              "E-mail"
                                                ? response.email
                                                : "",
                                            attyemail: response.attypref
                                              ? response.attyemail
                                              : "",
                                          },
                                          false
                                        );
                                      }
                                    } else {
                                      toast.error(
                                        "Judicial District is required"
                                      );
                                    }
                                  }}
                                  disabled={
                                    generatingFirst || generatingFirstJoint
                                  }
                                >
                                  {/* <FaFileAlt size={16}  /> */}
                                  <img
                                    src={generateIcon}
                                    alt="generate"
                                    style={{ width: 18, height: 18 }}
                                  />
                                  {generatingFirst ? (
                                    <ThreeDots
                                      height="20"
                                      width="160"
                                      radius="9"
                                      color="#FDE47F"
                                      ariaLabel="three-dots-loading"
                                      wrapperStyle={{
                                        display: "block",
                                      }}
                                      wrapperClassName="spinner"
                                      visible={true}
                                    />
                                  ) : (
                                    "Generate CC Certificate"
                                  )}
                                </button>
                              )}
                            {/* {
                              console.log("asfdasd",values.courseFirstEnrol,courseData)
                            } */}
                            {values.courseFirstEnrol &&
                              courseData?.courseFirstGenerated == "yes" &&
                              (courseData.courseFirstDownloaded &&
                              courseData.courseFirstDownloaded !== "" ? (
                                <a
                                  className="text-inherit"
                                  href={courseData.courseFirstDownloaded}
                                  target="_blank"
                                >
                                  <button
                                    className="view-certificate-btn  "
                                    type="button"
                                  >
                                    <FaEye size={16} />
                                    View CC Certificate
                                  </button>
                                </a>
                              ) : (
                                <button
                                  className="view-certificate-btn   tooltips"
                                  type="button"
                                >
                                  <FaEye size={16} />
                                  View CC Certificate
                                </button>
                              ))}
                          </div>
                          {/* {values.courseFirstEnrol && certificateCounts?.CCMainCount > 0 && (
                              <div className="col-lg-6">
                                <div
                                  style={{
                                    marginTop: "10px",
                                    backgroundColor: "#f1fdf6",
                                    border: "1px solid #28a745",
                                    borderRadius: "8px",
                                    padding: "8px 12px",
                                    fontWeight: "600",
                                    color: "#155724",
                                    textAlign: "center",
                                    width: "fit-content",
                                  }}
                                >
                                  Certificates:{" "}
                                  <span style={{ color: "#28a745", fontSize: "16px" }}>
                                    {certificateCounts?.CCMainCount}
                                  </span>
                                </div>
                              </div>
                            )} */}

                          <div className="col-lg-12 mt-4">
                            <div className="col-lg-12 ">
                              {values.courseFirstEnrol &&
                                courseData?.courseFirstGenerated == "yes" && (
                                  <div
                                    className=" input_wrap"
                                    style={{ marginBottom: "30px" }}
                                  >
                                    <label className="label-title">
                                      CC Date
                                    </label>
                                    <input
                                      type="text"
                                      readOnly
                                      className="form-control"
                                      value={
                                        courseData?.courseFirstDate?.split(
                                          "T"
                                        )[0] ?? ""
                                      }
                                    />
                                    {errors.start && touched.start ? (
                                      <p className="text-danger">
                                        {errors.start}
                                      </p>
                                    ) : null}
                                  </div>
                                )}
                            </div>
                            {values.courseFirstEnrol && (
                              <div className="col-lg-12">
                                {/* <div className=" input_wrap d-flex">
                                <label className="label-title">CC Cert</label>
                                <div className="file-uplaod form-control">
                                  <input
                                    type="file"
                                    className="form-control"
                                    onChange={(e) => {
                                      setFirstPDF(e.target.files[0]);
                                    }}
                                  />
                                  {firstPDF ? (
                                    firstPDF.name
                                  ) : (
                                    <>
                                      {" "}
                                      <p>No file selected...</p>
                                      <span> Brows...</span>
                                    </>
                                  )}
                                </div>
                                <button
                                    className="btn_brnd"
                                    type="button"
                                    disabled={uploadingFirst || !firstPDF}
                                    onClick={() => {
                                      setUploadingFirst(true);
                                      uploadCertificate(
                                        "first",
                                        {
                                          courseId: courseData.courseFirstId,
                                          course: "first",
                                          email:
                                            response.deliverymethod == "E-mail"
                                              ? response.email
                                              : "",
                                          attyemail: response.attypref
                                            ? response.attyemail
                                            : "",
                                          file: firstPDF,
                                        },
                                        false
                                      );
                                    }}
                                  >
                                    {uploadingFirst ? (
                                      <ThreeDots
                                        height="20"
                                        width="150"
                                        radius="9"
                                        color="#4fa94d"
                                        ariaLabel="three-dots-loading"
                                        wrapperStyle={{
                                          display: "block",
                                        }}
                                        wrapperClassName="spinner"
                                        visible={true}
                                      />
                                    ) : (
                                      "Upload CC Certificate"
                                    )}
                                  </button>
                              </div> */}

                                <div className="certificate-upload-section">
                                  {/* <label className="label-title">CC Certificate</label> */}
                                  <div
                                    className=" input_wrap d-flex"
                                    style={{ marginBottom: "30px" }}
                                  >
                                    <label className="label-title">
                                      CC Cert
                                    </label>
                                    <div className="file-uplaod form-control">
                                      <input
                                        type="file"
                                        className="form-control "
                                        disabled={uploadingFirst}
                                        onChange={(e) => {
                                          const file = e.target.files[0];
                                          if (file) {
                                            setFirstPDF(file);
                                            setUploadingFirst(true);
                                            uploadCertificate(
                                              "first",
                                              {
                                                courseId:
                                                  courseData.courseFirstId,
                                                course: "first",
                                                email:
                                                  response.deliverymethod ==
                                                  "E-mail"
                                                    ? response.email
                                                    : "",
                                                attyemail: response.attypref
                                                  ? response.attyemail
                                                  : "",
                                                file: file,
                                              },
                                              false
                                            );
                                          }
                                        }}
                                      />
                                      {firstPDF ? (
                                        firstPDF.name
                                      ) : (
                                        <>
                                          {" "}
                                          <p>No file selected...</p>
                                          <span> Brows...</span>
                                        </>
                                      )}

                                      {/* Icon inside input */}
                                      <span className="certificate-icon-inside">
                                        {uploadingFirst ? (
                                          <ThreeDots
                                            height="30"
                                            width="40"
                                            radius="9"
                                            color="#4fa94d"
                                            ariaLabel="three-dots-loading"
                                            visible={true}
                                          />
                                        ) : (
                                          <FiUpload size={18} color="#4fa94d" />
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-lg-6  w-100">
                                  <div
                                    className="form-text"
                                    style={{
                                      display: "flex",
                                      // alignItems: "flex-start",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      marginTop: "0",
                                    }}
                                  >
                                    <div className="col-lg-4">
                                      {values.courseFirstEnrol &&
                                        courseData?.courseFirstGenerated ==
                                          "yes" &&
                                        courseData.courseFirstDownloaded &&
                                        courseData.courseFirstDownloaded !==
                                          "" && (
                                          <span
                                            // className="btn_brnd mb-lg-0 "
                                            style={{
                                              color: "#4e9c4b",
                                              fontSize: "16px",
                                              fontWeight: "600",
                                              textDecorationLine: "underline",
                                              // width: "40%",
                                              cursor: "pointer",
                                            }}
                                            // type="button"
                                            disabled={resendingFirstToUser}
                                            onClick={() => {
                                              setResendingFirstToUser(true);
                                              resendCertificate(
                                                {
                                                  firstName: values.firstname,
                                                  lastName: values.lastname,
                                                  link: courseData.courseFirstDownloaded,
                                                  email: values.email,
                                                  userid: userId,
                                                  course: "CC",
                                                  type: "Main",
                                                  //   attyEmail: values.attyemail,
                                                  // secondaryEmail: secEmails
                                                },
                                                setResendingFirstToUser
                                              );
                                            }}
                                          >
                                            {resendingFirstToUser ? (
                                              <span className="resend-btn">
                                                <ThreeDots
                                                  height="20"
                                                  width="120"
                                                  radius="9"
                                                  color="#4fa94d"
                                                  ariaLabel="three-dots-loading"
                                                  wrapperStyle={{
                                                    display: "block",
                                                  }}
                                                  wrapperClassName="spinner"
                                                  visible={true}
                                                />
                                              </span>
                                            ) : (
                                              "Resend To User"
                                            )}
                                          </span>
                                        )}
                                    </div>
                                    <div
                                      className="col-lg-4"
                                      style={{ textAlign: "center" }}
                                    >
                                      {values.courseFirstEnrol &&
                                        courseData?.courseFirstGenerated ==
                                          "yes" &&
                                        courseData.courseFirstDownloaded &&
                                        courseData.courseFirstDownloaded !==
                                          "" && (
                                          <span
                                            // className="btn_brnd mb-lg-0 "
                                            style={{
                                              color: "#4e9c4b",
                                              fontSize: "16px",
                                              fontWeight: "600",
                                              textDecorationLine: "underline",
                                              // width: "40%",
                                              cursor: "pointer",
                                            }}
                                            // type="button"
                                            disabled={resendingFirstToAttorney}
                                            onClick={() => {
                                              setResendingFirstAttorney(true);
                                              resendCertificateToAttorney(
                                                buildAttorneyResendPayload({
                                                  firstName: values.firstname,
                                                  lastName: values.lastname,
                                                  link: courseData.courseFirstDownloaded,
                                                  attyEmail: values.attyemail,
                                                  course: "CC",
                                                  type: "Main",
                                                }),
                                                setResendingFirstAttorney
                                              );
                                            }}
                                          >
                                            {resendingFirstToAttorney ? (
                                              <span className="resend-btn">
                                                <ThreeDots
                                                  height="20"
                                                  width="120"
                                                  radius="9"
                                                  color="#4fa94d"
                                                  ariaLabel="three-dots-loading"
                                                  wrapperStyle={{
                                                    display: "block",
                                                  }}
                                                  wrapperClassName="spinner"
                                                  visible={true}
                                                />
                                              </span>
                                            ) : (
                                              "Resend To Attorney"
                                            )}
                                          </span>
                                        )}
                                    </div>
                                    <div
                                      className="col-lg-4"
                                      style={{ textAlign: "end" }}
                                    >
                                      {values.courseFirstEnrol && (
                                        <Link
                                          to={
                                            inCompleteUserInfo
                                              ? `/beforecontactwithcounselor?id=${userId}&course=first`
                                              : `/user-first-course?id=${userId}`
                                            // `/user-first-course?id=${userId}`
                                          }
                                          //   style={{
                                          //   color: "#4e9c4b",
                                          //   fontSize: "16px",
                                          //   fontWeight: "600",
                                          //   textDecorationLine: "underline",
                                          //   width: "40%",
                                          // }}
                                          style={{
                                            color: "#4e9c4b",
                                            fontSize: "16px",
                                            fontWeight: "600",
                                            textDecorationLine: "underline",
                                            // width: "40%",
                                          }}
                                        >
                                          {/* <button
                                          className="btn_brnd">
                                          Continue Course
                                        </button> */}
                                          Continue Course
                                        </Link>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          {values.joint_username && (
                            <>
                              <div
                                className="col-lg-12 mt-5"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "20px",
                                }}
                              >
                                {values.courseFirstEnrol && (
                                  // <div className="col-lg-12 fw-bold">
                                  <h5
                                    style={{
                                      fontWeight: "600",
                                      fontSize: "17px",
                                      marginBottom: "0",
                                    }}
                                  >
                                    Joint Filer{" "}
                                    <span style={{ fontSize: "14px" }}>
                                      {" "}
                                      (
                                      {courseData.perFirstCourseJoint &&
                                        courseData.perFirstCourseJoint.toFixed(
                                          0
                                        )}
                                      % Completed)
                                    </span>
                                  </h5>
                                  // </div>
                                )}
                                {/* <div className="col-lg-6"> */}
                                  {values.courseFirstEnrol &&
                                    courseData.jointCourseFirstGenerated ==
                                      "" && (
                                      <button
                                        type="button"
                                        className="view-certificate-btn"
                                        onClick={() => {
                                          if (values.judicialdistrict_first) {
                                            setGeneratingFirstJoint(true);

                                            if (
                                              response.judicialdistrict_first !==
                                              values.judicialdistrict_first
                                            ) {
                                              setPostLoading(true);
                                              updateProfile(userId, values)
                                                .then((res) => {
                                                  toast.success(
                                                    "User updated successfully"
                                                  );
                                                  setPostLoading(false);
                                                  generateCertificate(
                                                    {
                                                      courseMainId:
                                                        courseData.courseFirstId,
                                                      courseJointId:
                                                        courseData.jointCourseFirstId,
                                                      main:
                                                        courseData.perFirstCourseMain ===
                                                        100,
                                                      joint: true,
                                                      course: "first",
                                                      email:
                                                        response.deliverymethod ==
                                                        "E-mail"
                                                          ? response.email
                                                          : "",
                                                      attyemail:
                                                        response.attypref
                                                          ? response.attyemail
                                                          : "",
                                                    },
                                                    true
                                                  );
                                                })
                                                .catch((err) => {
                                                  toast.error(
                                                    err.response.data.error
                                                  );
                                                  setPostLoading(false);
                                                });
                                            } else {
                                              generateCertificate(
                                                {
                                                  courseMainId:
                                                    courseData.courseFirstId,
                                                  courseJointId:
                                                    courseData.jointCourseFirstId,
                                                  course: "first",
                                                  main:
                                                    courseData.perFirstCourseMain ===
                                                    100,
                                                  joint: true,
                                                  email:
                                                    response.deliverymethod ==
                                                    "E-mail"
                                                      ? response.email
                                                      : "",
                                                  attyemail: response.attypref
                                                    ? response.attyemail
                                                    : "",
                                                },
                                                true
                                              );
                                            }
                                          } else {
                                            toast.error(
                                              "Judicial District is required"
                                            );
                                          }
                                        }}
                                        disabled={
                                          generatingFirstJoint ||
                                          generatingFirst
                                        }
                                      >
                                        {/* <FaFileAlt size={16} /> */}
                                        <img
                                    src={generateIcon}
                                    alt="generate"
                                    style={{ width: 18, height: 18 }}
                                  />
                                        {generatingFirstJoint ? (
                                          <ThreeDots
                                            height="20"
                                            width="160"
                                            radius="9"
                                            color="#FDE47F"
                                            ariaLabel="three-dots-loading"
                                            wrapperStyle={{
                                              display: "block",
                                            }}
                                            wrapperClassName="spinner"
                                            visible={true}
                                          />
                                        ) : (
                                          "Generate CC Certificate"
                                        )}
                                      </button>
                                    )}
                                  {values.courseFirstEnrol &&
                                    courseData.jointCourseFirstGenerated ==
                                      "yes" &&
                                    (courseData.jointCourseFirstDownloaded &&
                                    courseData.jointCourseFirstDownloaded !==
                                      "" ? (
                                      <a
                                        className="text-inherit"
                                        href={
                                          courseData.jointCourseFirstDownloaded
                                        }
                                        target="_blank"
                                        style={{
                                          display: "inline-block",
                                        }}
                                      >
                                        <button
                                          className="view-certificate-btn"
                                          type="button"
                                        >
                                          <FaEye size={16} />
                                          View CC Certificate
                                        </button>
                                      </a>
                                    ) : (
                                      <button
                                        className="view-certificate-btn  tooltips"
                                        type="button"
                                      >
                                        <FaEye size={16} />
                                        View CC Certificate
                                      </button>
                                    ))}
                                {/* </div> */}
                                {/* {values.courseFirstEnrol && certificateCounts?.CCJointCount > 0 && (
                              <div className="col-lg-6">
                                <div
                                  style={{
                                    marginTop: "10px",
                                    backgroundColor: "#f1fdf6",
                                    border: "1px solid #28a745",
                                    borderRadius: "8px",
                                    padding: "8px 12px",
                                    fontWeight: "600",
                                    color: "#155724",
                                    textAlign: "center",
                                    width: "fit-content",
                                  }}
                                >
                                  Certificates:{" "}
                                  <span style={{ color: "#28a745", fontSize: "16px" }}>
                                    {certificateCounts?.CCJointCount}
                                  </span>
                                </div>
                              </div>
                            )} */}
                              </div>
                              <div className="col-lg-12 mt-4">
                                <div className="col-lg-12">
                                  {values.courseFirstEnrol &&
                                    courseData.jointCourseFirstGenerated ==
                                      "yes" && (
                                      <div
                                        className=" input_wrap"
                                        style={{ marginBottom: "30px" }}
                                      >
                                        <label className="label-title">
                                          CC Date
                                        </label>
                                        <input
                                          type="text"
                                          readOnly
                                          className="form-control"
                                          value={
                                            courseData?.jointCourseFirstDate?.split(
                                              "T"
                                            )[0] ?? ""
                                          }
                                        />
                                        {errors.start && touched.start ? (
                                          <p className="text-danger">
                                            {errors.start}
                                          </p>
                                        ) : null}
                                      </div>
                                    )}
                                </div>
                                {values.courseFirstEnrol && (
                                  <div className=" certificate-upload-section">
                                    <div
                                      className=" input_wrap d-flex"
                                      style={{ marginBottom: "30px" }}
                                    >
                                      <label className="label-title">
                                        CC Cert
                                      </label>
                                      <div className="file-uplaod form-control">
                                        <input
                                          type="file"
                                          className="form-control"
                                          disabled={uploadingFirstJoint}
                                          // onChange={(e) => {
                                          //   setFirstPDFJoint(e.target.files[0]);

                                          // }}
                                          onChange={(e) => {
                                            const file = e.target.files[0];
                                            if (file) {
                                              setFirstPDFJoint(file);
                                              setUploadingFirstJoint(true);
                                              uploadCertificate(
                                                "first",
                                                {
                                                  courseId:
                                                    courseData.jointCourseFirstId,
                                                  course: "first",
                                                  email:
                                                    response.deliverymethod ==
                                                    "E-mail"
                                                      ? response.email
                                                      : "",
                                                  attyemail: response.attypref
                                                    ? response.attyemail
                                                    : "",
                                                  file: file,
                                                },
                                                true
                                              );
                                            }
                                          }}
                                        />
                                        {firstPDFJoint ? (
                                          firstPDFJoint.name
                                        ) : (
                                          <>
                                            {" "}
                                            <p>No file selected...</p>
                                            <span> Brows...</span>
                                          </>
                                        )}
                                        <span className="certificate-icon-inside">
                                          {uploadingFirstJoint ? (
                                            <ThreeDots
                                              height="30"
                                              width="40"
                                              radius="9"
                                              color="#4fa94d"
                                              ariaLabel="three-dots-loading"
                                              visible={true}
                                            />
                                          ) : (
                                            <FiUpload
                                              size={18}
                                              color="#4fa94d"
                                            />
                                          )}
                                        </span>
                                      </div>
                                    </div>
                                    <div style={{ display: "flex" }}>
                                      <div className="col-lg-6">
                                        {/* <button
                                        className="btn_brnd"
                                        type="button"
                                        disabled={
                                          uploadingFirstJoint || !firstPDFJoint
                                        }
                                        onClick={() => {
                                          setUploadingFirstJoint(true);
                                          uploadCertificate(
                                            "first",
                                            {
                                              courseId:
                                                courseData.jointCourseFirstId,
                                              course: "first",
                                              email:
                                                response.deliverymethod ==
                                                "E-mail"
                                                  ? response.email
                                                  : "",
                                              attyemail: response.attypref
                                                ? response.attyemail
                                                : "",
                                              file: firstPDFJoint,
                                            },
                                            true
                                          );
                                        }}
                                      >
                                        {uploadingFirstJoint ? (
                                          <ThreeDots
                                            height="20"
                                            width="150"
                                            radius="9"
                                            color="#4fa94d"
                                            ariaLabel="three-dots-loading"
                                            wrapperStyle={{
                                              display: "block",
                                            }}
                                            wrapperClassName="spinner"
                                            visible={true}
                                          />
                                        ) : (
                                          "Upload CC Certificate"
                                        )}
                                      </button> */}
                                        {values.courseFirstEnrol &&
                                          courseData.jointCourseFirstGenerated ==
                                            "yes" &&
                                          courseData.jointCourseFirstDownloaded &&
                                          courseData.jointCourseFirstDownloaded !==
                                            "" && (
                                            <span
                                              // className="btn_brnd "
                                              style={{
                                                color: "#4e9c4b",
                                                fontSize: "16px",
                                                fontWeight: "600",
                                                textDecorationLine: "underline",
                                                // width: "40%",
                                                cursor: "pointer",
                                              }}
                                              // type="button"
                                              disabled={
                                                resendingFirstJointToUser
                                              }
                                              onClick={() => {
                                                setResendingFirstJointToUser(
                                                  true
                                                );
                                                resendCertificate(
                                                  {
                                                    firstName:
                                                      values.joint_firstname,
                                                    lastName:
                                                      values.joint_lastname,
                                                    link: courseData.jointCourseFirstDownloaded,
                                                    email: values.email,
                                                    userid: userId,
                                                    course: "CC",
                                                    type: "Joint",
                                                    //       attyEmail: values.attyemail,
                                                    // secondaryEmail: secEmails
                                                  },
                                                  setResendingFirstJointToUser
                                                );
                                              }}
                                            >
                                              {resendingFirstJointToUser ? (
                                                <span className="resend-btn">
                                                  <ThreeDots
                                                    height="20"
                                                    width="120"
                                                    radius="9"
                                                    color="#4fa94d"
                                                    ariaLabel="three-dots-loading"
                                                    wrapperStyle={{
                                                      display: "block",
                                                    }}
                                                    wrapperClassName="spinner"
                                                    visible={true}
                                                  />
                                                </span>
                                              ) : (
                                                "Resend To User"
                                              )}
                                            </span>
                                          )}
                                      </div>
                                      <div className="col-lg-6">
                                        {/* <button
                                        className="btn_brnd"
                                        type="button"
                                        disabled={
                                          uploadingFirstJoint || !firstPDFJoint
                                        }
                                        onClick={() => {
                                          setUploadingFirstJoint(true);
                                          uploadCertificate(
                                            "first",
                                            {
                                              courseId:
                                                courseData.jointCourseFirstId,
                                              course: "first",
                                              email:
                                                response.deliverymethod ==
                                                "E-mail"
                                                  ? response.email
                                                  : "",
                                              attyemail: response.attypref
                                                ? response.attyemail
                                                : "",
                                              file: firstPDFJoint,
                                            },
                                            true
                                          );
                                        }}
                                      >
                                        {uploadingFirstJoint ? (
                                          <ThreeDots
                                            height="20"
                                            width="150"
                                            radius="9"
                                            color="#4fa94d"
                                            ariaLabel="three-dots-loading"
                                            wrapperStyle={{
                                              display: "block",
                                            }}
                                            wrapperClassName="spinner"
                                            visible={true}
                                          />
                                        ) : (
                                          "Upload CC Certificate"
                                        )}
                                      </button> */}
                                        {values.courseFirstEnrol &&
                                          courseData.jointCourseFirstGenerated ==
                                            "yes" &&
                                          courseData.jointCourseFirstDownloaded &&
                                          courseData.jointCourseFirstDownloaded !==
                                            "" && (
                                            <span
                                              // className="btn_brnd "
                                              style={{
                                                color: "#4e9c4b",
                                                fontSize: "16px",
                                                fontWeight: "600",
                                                textDecorationLine: "underline",
                                                // width: "40%",
                                                cursor: "pointer",
                                              }}
                                              // type="button"
                                              disabled={
                                                resendingFirstJointToAttorney
                                              }
                                              onClick={() => {
                                                setResendingFirstJointToAttorney(
                                                  true
                                                );
                                                resendCertificateToAttorney(
                                                  buildAttorneyResendPayload({
                                                    firstName:
                                                      values.joint_firstname,
                                                    lastName:
                                                      values.joint_lastname,
                                                    link: courseData.jointCourseFirstDownloaded,
                                                    attyEmail: values.attyemail,
                                                    course: "CC",
                                                    type: "Joint",
                                                  }),
                                                  setResendingFirstJointToAttorney
                                                );
                                              }}
                                            >
                                              {resendingFirstJointToAttorney ? (
                                                <span className="resend-btn">
                                                  <ThreeDots
                                                    height="20"
                                                    width="120"
                                                    radius="9"
                                                    color="#4fa94d"
                                                    ariaLabel="three-dots-loading"
                                                    wrapperStyle={{
                                                      display: "block",
                                                    }}
                                                    wrapperClassName="spinner"
                                                    visible={true}
                                                  />
                                                </span>
                                              ) : (
                                                "Resend To Attorney"
                                              )}
                                            </span>
                                          )}
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </>
                          )}
                          {values.courseFirstEnrol && (
                            // <div class="col-lg-8" style={{display:'flex'}}>
                            <div
                              className="btn_wrap mt-5"
                              style={{ textAlign: "center" }}
                            >
                              <button
                                type="button"
                                className="btn_brnd"
                                disabled={cancelEnrollLoaderFirst}
                                style={{ padding: "10px 18px" }}
                                //           style={{
                                //   color: "#4e9c4b",
                                //   fontSize: "16px",
                                //   fontWeight: "600",
                                //   textDecorationLine: "underline",
                                //   width: "40%",
                                // }}
                                onClick={() => {
                                  setCancelEnrollData({
                                    // value:'first',
                                    id: values.id,
                                    cource: "first",
                                  });
                                  setIsModal(true);
                                  // handleUnEnroll(values.id,"first",setValues,values)
                                }}
                              >
                                Cancel Enrollment CC
                              </button>
                            </div>
                          )}
                        </div>
                      </div>

                      <div
                        className="col-lg-6"
                        style={{
                          border: "1px solid #D4D6D7",
                          borderRadius: "24px",
                          padding: "25px 35px",
                        }}
                      >
                        <div
                          className="row"
                          //   style={{
                          //   border: '1px solid #D4D6D7',
                          //   borderRadius: '24px',
                          //   padding: '25px 35px'
                          // }}
                        >
                          <div
                            className="client-head"
                            style={{
                              backgroundColor: "transparent",
                              marginBottom: "20px",
                              // marginTop: "-30px",
                            }}
                          >
                            <div className="row align-items-center">
                              <div className="col-lg-12">
                                <div class="row">
                                  <div class="col-lg-5">
                                    <h1>Debtor Education</h1>
                                  </div>
                                  {values.courseSecondEnrol && (
                                    <div
                                      class="col-lg-7"
                                      style={{
                                        display: "flex",
                                        justifyContent: "end",
                                        alignItems: "center",
                                        gap: "24px",
                                      }}
                                    >
                                      <Link
                                        to={`/courseprogress?id=${userId}&course=second`}
                                        // className="ms-4"
                                        style={{
                                          color: "#4e9c4b",
                                          fontSize: "16px",
                                          fontWeight: "600",
                                          textDecorationLine: "underline",
                                          // width: "40%",
                                        }}
                                      >
                                        {/* <button type="button" className="btn_brnd">
                                  Course Progress
                                </button> */}
                                        Course Progress
                                      </Link>
                                    </div>
                                  )}

                                  {/* {values.courseSecondEnrol && (
                                  <div class="col-lg-7">
                                    <div className="btn_wrap text-center">
                                      <button
                                        type="button"
                                        className=" btn_brnd"
                                        // data-bs-toggle="modal"
                                        // data-bs-target="#nonSerious"

                                        disabled={cancelEnrollLoader}
                                        style={{ padding: "10px 18px" }}
                                        // onClick={()=>handleUnEnroll(values.id,"second",setValues,values)}
                                        onClick={() => {
                                          setCancelEnrollData({
                                            // value:'first',
                                            id: values.id,
                                            cource: "second",
                                          });
                                          console.log("values.id", values.id);

                                          setIsModal(true);
                                          // handleUnEnroll(values.id,"first",setValues,values)
                                        }}
                                      >
                                        Cancel Enrollment
                                      </button>
                                    </div>
                                  </div>
                                )} */}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="iagree_radio ">
                            <div className="d-flex" style={{ gap: "30px" }}>
                              <div className="w-30">
                                {/* <div className="iagree_radio mb-3"> */}
                                <div>
                                  <input
                                    type="checkbox"
                                    name="tickbox"
                                    checked={values.paid_second === "checked"}
                                    onChange={(e) => {
                                      setValues({
                                        ...values,
                                        paid_second: e.target.checked
                                          ? "checked"
                                          : "",
                                      });
                                    }}
                                    id="paid_second"
                                    className=" "
                                  />
                                  <label for="paid_second">Paid </label>
                                </div>
                                {errors.start && touched.start ? (
                                  <p className="text-danger">{errors.start}</p>
                                ) : null}
                                {/* </div> */}
                              </div>

                              {values.courseSecondEnrol && (
                                <div className="w-30">
                                  <div className="iagree_radio">
                                    <div>
                                      <input
                                        type="checkbox"
                                        onChange={() => {
                                          setValues({
                                            ...values,
                                            secondPhone:
                                              values.secondPhone == 1 ? 0 : 1,
                                          });
                                        }}
                                        onBlur={handleBlur}
                                        checked={values.secondPhone == 1}
                                        id="secondPhone"
                                        className=""
                                      />
                                      <label for="secondPhone">Phone</label>
                                    </div>
                                  </div>
                                </div>
                              )}

                              {/* <div className="iagree_radio mb-3">
                            <div>
                              <input
                                type="checkbox"
                                name="tickbox"
                                id=""
                                className=" "
                              />
                              <label for="">Taken by phone: </label>
                            </div>
                            {errors.start && touched.start ? (
                              <p className="text-danger">{errors.start}</p>
                            ) : null}
                          </div> */}
                            </div>

                            {values.courseSecondEnrol ? (
                              <></>
                            ) : (
                              // <div className="mt-4 mb-4">
                              //   <Link to={
                              //     inCompleteUserInfo
                              //       ? `/beforecontactwithcounselor?id=${userId}&course=second`
                              //       : `/user-second-course?id=${userId}`
                              //     // `/user-second-course?id=${userId}`
                              //   }>
                              //     <button className="btn_brnd">
                              //       Continue Course
                              //     </button>
                              //   </Link>
                              //   <Link
                              //     to={`/courseprogress?id=${userId}&course=second`}
                              //     className="ms-4"
                              //   >
                              //     <button type="button" className="btn_brnd">
                              //       Course Progress
                              //     </button>
                              //   </Link>
                              // </div>
                              <div className="mt-4 mb-4 ">
                                <button type="button" className="btn_brnd" disabled={enrollmentLoading} onClick={() => startEnrollment("second")}>
                                    {enrollmentLoading ? "Loading..." : "Enroll Now"}
                                  </button>
                              </div>
                            )}
                          </div>
                          {/* {values.courseSecondEnrol && values.payment_second && (
                       <div className="mb-5 mt-3" style={{ marginTop: '1rem', marginBottom: '1rem',display:'flex', alignItems:'center',gap:'10px'}}>
                       <h5 style={{ fontWeight: "600", fontSize: "17px" }}>
                         Payment Mode:
                       </h5>
                     
                       <div style={{ 
                         display: 'inline-block',
                         backgroundColor: '#e5f3ea',
                         color: '#166534',
                         padding: '10px 16px',
                         borderRadius: '8px',
                         fontWeight: '600',
                         fontSize: '15px',
                         boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
                       }}>
                         {(values.payment_second === "bill" || values.payment_second === "DE")
                           ? "Paid By Attorney"
                           : values.payment_second === "Admin manually checked"
                             ? "Paid By Admin"
                             : "Credit Card"}
                       </div>
                     </div>
                         )} */}
                          <div
                            className="col-lg-12 "
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "20px",
                              marginTop: "2.5rem",
                            }}
                          >
                            {values.courseSecondEnrol && (
                              // <div className="col-lg-12 fw-bold">
                              <h5
                                style={{
                                  fontWeight: "600",
                                  fontSize: "17px",
                                  marginBottom: "0",
                                }}
                              >
                                Main Filer{" "}
                                <span style={{ fontSize: "14px" }}>
                                  {" "}
                                  ({courseData.perSecondCourseMain.toFixed(0)}%
                                  Completed)
                                </span>
                              </h5>
                              // </div>
                            )}
                            {/* <div className="col-lg-6"> */}
                              {values.courseSecondEnrol &&
                                courseData.generated == "" && (
                                  <button
                                    className="view-certificate-btn"
                                    type="button"
                                    onClick={() => {
                                      if (values.judicialdistrict_second) {
                                        setGeneratingSecond(true);

                                        if (
                                          response.judicialdistrict_second !==
                                          values.judicialdistrict_second
                                        ) {
                                          setPostLoading(true);
                                          updateProfile(userId, values)
                                            .then((res) => {
                                              toast.success(
                                                "User updated successfully"
                                              );
                                              setPostLoading(false);
                                              generateCertificateSecond({
                                                sendEmail: courseData.sendEmail,
                                                courseId:
                                                  courseData.courseSecondId,
                                                jointCourseId:
                                                  courseData.jointCourseSecondId,
                                                course: "second",
                                                bankruptcycasenum:
                                                  courseData.bankruptcycasenum,
                                                email:
                                                  response.deliverymethod ==
                                                  "E-mail"
                                                    ? response.email
                                                    : "",
                                                attyemail: response.attypref
                                                  ? response.attyemail
                                                  : "",
                                              });
                                            })
                                            .catch((err) => {
                                              toast.error(
                                                err.response.data.error
                                              );
                                              setPostLoading(false);
                                            });
                                        } else {
                                          generateCertificateSecond({
                                            sendEmail: courseData.sendEmail,
                                            courseId: courseData.courseSecondId,
                                            jointCourseId:
                                              courseData.jointCourseSecondId,
                                            course: "second",
                                            bankruptcycasenum:
                                              courseData.bankruptcycasenum,
                                            email:
                                              response.deliverymethod ==
                                              "E-mail"
                                                ? response.email
                                                : "",
                                            attyemail: response.attypref
                                              ? response.attyemail
                                              : "",
                                          });
                                        }
                                      } else {
                                        toast.error(
                                          "Judicial District is required"
                                        );
                                      }
                                    }}
                                    disabled={
                                      generatingSecond || generatingSecondJoint
                                    }
                                  >
                                    {/* <FaFileAlt size={16} /> */}
                                    <img
                                    src={generateIcon}
                                    alt="generate"
                                    style={{ width: 18, height: 18 }}
                                  />
                                    {generatingSecond ? (
                                      <ThreeDots
                                        height="20"
                                        width="160"
                                        radius="9"
                                        color="#FDE47F"
                                        ariaLabel="three-dots-loading"
                                        wrapperStyle={{
                                          display: "block",
                                        }}
                                        wrapperClassName="spinner"
                                        visible={true}
                                      />
                                    ) : (
                                      "Generate DE Certificate"
                                    )}
                                  </button>
                                )}
                              {values.courseSecondEnrol &&
                                courseData.generated == "yes" &&
                                (courseData.downloaded &&
                                courseData.downloaded !== "" ? (
                                  <a
                                    href={courseData.downloaded}
                                    target="_blank"
                                    style={{
                                      display: "inline-block",
                                    }}
                                  >
                                    <button
                                      className="view-certificate-btn "
                                      type="button"
                                    >
                                      <FaEye size={16} />
                                      View DE Certificate
                                    </button>
                                  </a>
                                ) : (
                                  <button
                                    className="view-certificate-btn  tooltips"
                                    type="button"
                                  >
                                    <FaEye size={16} />
                                    View DE Certificate
                                  </button>
                                ))}
                            {/* </div> */}
                          </div>
                          {/* {values.courseSecondEnrol && certificateCounts?.DEMainCount > 0 && (
                              <div className="col-lg-6">
                                <div
                                  style={{
                                    marginTop: "10px",
                                    backgroundColor: "#f1fdf6",
                                    border: "1px solid #28a745",
                                    borderRadius: "8px",
                                    padding: "8px 12px",
                                    fontWeight: "600",
                                    color: "#155724",
                                    textAlign: "center",
                                    width: "fit-content",
                                  }}
                                >
                                  Certificates:{" "}
                                  <span style={{ color: "#28a745", fontSize: "16px" }}>
                                    {certificateCounts?.DEMainCount}
                                  </span>
                                </div>
                              </div>
                            )} */}
                          <div className="col-lg-12 mt-4">
                            <div className="col-lg-12">
                              {values.courseSecondEnrol &&
                                courseData.generated && (
                                  <div
                                    className=" input_wrap"
                                    style={{ marginBottom: "30px" }}
                                  >
                                    <label className="label-title">
                                      DE Date
                                    </label>
                                    <input
                                      type="text"
                                      readOnly
                                      className="form-control"
                                      value={
                                        courseData?.date?.split("T")[0] ?? ""
                                      }
                                    />
                                    {errors.start && touched.start ? (
                                      <p className="text-danger">
                                        {errors.start}
                                      </p>
                                    ) : null}
                                  </div>
                                )}
                            </div>
                            {values.courseSecondEnrol && (
                              <div className="col-lg-12">
                                <div className="certificate-upload-section">
                                  <div
                                    className=" input_wrap d-flex"
                                    style={{ marginBottom: "30px" }}
                                  >
                                    <label className="label-title">
                                      DE Cert
                                    </label>
                                    <div className="file-uplaod form-control">
                                      <input
                                        type="file"
                                        className="form-control"
                                        disabled={uploadingSecond}
                                        onChange={(e) => {
                                          // setSecondPDF(e.target.files[0]);

                                          const file = e.target.files[0];
                                          if (file) {
                                            setSecondPDF(file);
                                            setUploadingSecond(true);
                                            uploadCertificate(
                                              "second",
                                              {
                                                courseId:
                                                  courseData.courseSecondId,
                                                course: "second",
                                                email:
                                                  response.deliverymethod ==
                                                  "E-mail"
                                                    ? response.email
                                                    : "",
                                                attyemail: response.attypref
                                                  ? response.attyemail
                                                  : "",
                                                file: file,
                                              },
                                              false
                                            );
                                          }
                                        }}
                                      />
                                      {secondPDF ? (
                                        secondPDF.name
                                      ) : (
                                        <>
                                          {" "}
                                          <p>No file selected...</p>
                                          <span> Brows...</span>
                                        </>
                                      )}
                                      <span className="certificate-icon-inside">
                                        {uploadingSecond ? (
                                          <ThreeDots
                                            height="30"
                                            width="40"
                                            radius="9"
                                            color="#4fa94d"
                                            ariaLabel="three-dots-loading"
                                            visible={true}
                                          />
                                        ) : (
                                          <FiUpload size={18} color="#4fa94d" />
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6 w-100">
                                  <div
                                    className="form-text"
                                    style={{
                                      display: "flex",
                                      // alignItems: "flex-start",
                                      justifyContent: "space-between",
                                      marginTop: "0",
                                      alignItems: "center",
                                    }}
                                  >
                                    {/* <button
                                    className="btn_brnd"
                                    type="button"
                                    disabled={uploadingSecond || !secondPDF}
                                    onClick={() => {
                                      setUploadingSecond(true);
                                      uploadCertificate(
                                        "second",
                                        {
                                          courseId: courseData.courseSecondId,
                                          course: "second",
                                          email:
                                            response.deliverymethod == "E-mail"
                                              ? response.email
                                              : "",
                                          attyemail: response.attypref
                                            ? response.attyemail
                                            : "",
                                          file: secondPDF,
                                        },
                                        false
                                      );
                                    }}
                                  >
                                    {uploadingSecond ? (
                                      <ThreeDots
                                        height="20"
                                        width="150"
                                        radius="9"
                                        color="#4fa94d"
                                        ariaLabel="three-dots-loading"
                                        wrapperStyle={{
                                          display: "block",
                                        }}
                                        wrapperClassName="spinner"
                                        visible={true}
                                      />
                                    ) : (
                                      "Upload DE Certificate"
                                    )}
                                  </button> */}
                                    <div className="col-lg-4">
                                      {values.courseSecondEnrol &&
                                        courseData.generated == "yes" &&
                                        courseData.downloaded &&
                                        courseData.downloaded !== "" && (
                                          <span
                                            // className="col-lg-6"
                                            // type="button"
                                            style={{
                                              color: "#4e9c4b",
                                              fontSize: "16px",
                                              fontWeight: "600",
                                              textDecorationLine: "underline",
                                              // width: "40%",
                                              cursor: "pointer",
                                            }}
                                            disabled={resendingSecondToUser}
                                            onClick={() => {
                                              setResendingSecondToUser(true);
                                              resendCertificate(
                                                {
                                                  firstName: values.firstname,
                                                  lastName: values.lastname,
                                                  link: courseData.downloaded,
                                                  email: values.email,
                                                  userid: userId,
                                                  course: "DE",
                                                  type: "Main",
                                                },
                                                setResendingSecondToUser
                                              );
                                            }}
                                          >
                                            {resendingSecondToUser ? (
                                              <span className="resend-btn">
                                                <ThreeDots
                                                  height="20"
                                                  width="120"
                                                  radius="9"
                                                  color="#4fa94d"
                                                  ariaLabel="three-dots-loading"
                                                  wrapperStyle={{
                                                    display: "block",
                                                  }}
                                                  wrapperClassName="spinner"
                                                  visible={true}
                                                />
                                              </span>
                                            ) : (
                                              "Resend To User"
                                            )}
                                          </span>
                                        )}
                                    </div>
                                    <div
                                      className="col-lg-4"
                                      style={{ textAlign: "center" }}
                                    >
                                      {values.courseSecondEnrol &&
                                        courseData.generated == "yes" &&
                                        courseData.downloaded &&
                                        courseData.downloaded !== "" && (
                                          <span
                                            // className="col-lg-6"
                                            // type="button"
                                            style={{
                                              color: "#4e9c4b",
                                              fontSize: "16px",
                                              fontWeight: "600",
                                              textDecorationLine: "underline",
                                              // width: "40%",
                                              cursor: "pointer",
                                            }}
                                            disabled={resendingSecondToAttorney}
                                            onClick={() => {
                                              setResendingSecondToAttorney(
                                                true
                                              );
                                              resendCertificateToAttorney(
                                                buildAttorneyResendPayload({
                                                  firstName: values.firstname,
                                                  lastName: values.lastname,
                                                  link: courseData.downloaded,
                                                  attyEmail: values.attyemail,
                                                  course: "DE",
                                                  type: "Main",
                                                }),
                                                setResendingSecondToAttorney
                                              );
                                            }}
                                          >
                                            {resendingSecondToAttorney ? (
                                              <span className="resend-btn">
                                                <ThreeDots
                                                  height="20"
                                                  width="120"
                                                  radius="9"
                                                  color="#4fa94d"
                                                  ariaLabel="three-dots-loading"
                                                  wrapperStyle={{
                                                    display: "block",
                                                  }}
                                                  wrapperClassName="spinner"
                                                  visible={true}
                                                />
                                              </span>
                                            ) : (
                                              "Resend To Attorney"
                                            )}
                                          </span>
                                        )}
                                    </div>
                                    <div
                                      className="col-lg-4"
                                      style={{ textAlign: "end" }}
                                    >
                                      {values.courseSecondEnrol && (
                                        <Link
                                          to={
                                            inCompleteUserInfo
                                              ? `/beforecontactwithcounselor?id=${userId}&course=second`
                                              : `/user-second-course?id=${userId}`
                                            // `/user-second-course?id=${userId}`
                                          }
                                          style={{
                                            color: "#4e9c4b",
                                            fontSize: "16px",
                                            fontWeight: "600",
                                            textDecorationLine: "underline",
                                            // width: "40%",
                                          }}
                                        >
                                          {/* <button className="btn_brnd">
                                            Continue Course
                                          </button> */}
                                          Continue Course
                                        </Link>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          {values.joint_username && (
                            <>
                              <div
                                className="col-lg-12 mt-5"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "20px",
                                }}
                              >
                                {values.courseSecondEnrol && (
                                  // <div className="col-lg-12 fw-bold">
                                  <h5
                                    style={{
                                      fontWeight: "600",
                                      fontSize: "17px",
                                      marginBottom: "0",
                                    }}
                                  >
                                    Joint Filer{" "}
                                    <span style={{ fontSize: "14px" }}>
                                      {" "}
                                      (
                                      {courseData.perSecondCourseJoint &&
                                        courseData.perSecondCourseJoint.toFixed(
                                          0
                                        )}
                                      % Completed)
                                    </span>
                                  </h5>
                                  // </div>
                                )}
                                {/* <div className="col-lg-6"> */}
                                  {values.courseSecondEnrol &&
                                    courseData.jointCourseSecondGenerated ==
                                      "" && (
                                      <button
                                        className="view-certificate-btn"
                                        type="button"
                                        onClick={() => {
                                          if (values.judicialdistrict_second) {
                                            setGeneratingSecondJoint(true);

                                            if (
                                              response.judicialdistrict_second !==
                                              values.judicialdistrict_second
                                            ) {
                                              setPostLoading(true);
                                              updateProfile(userId, values)
                                                .then((res) => {
                                                  toast.success(
                                                    "User updated successfully"
                                                  );
                                                  setPostLoading(false);
                                                  generateCertificateSecond({
                                                    sendEmail:
                                                      courseData.sendEmail,
                                                    courseId:
                                                      courseData.courseSecondId,
                                                    jointCourseId:
                                                      courseData.jointCourseSecondId,
                                                    course: "second",
                                                    bankruptcycasenum:
                                                      courseData.bankruptcycasenum,
                                                    email:
                                                      response.deliverymethod ==
                                                      "E-mail"
                                                        ? response.email
                                                        : "",
                                                    attyemail: response.attypref
                                                      ? response.attyemail
                                                      : "",
                                                  });
                                                })
                                                .catch((err) => {
                                                  toast.error(
                                                    err.response.data.error
                                                  );
                                                  setPostLoading(false);
                                                });
                                            } else {
                                              generateCertificateSecond({
                                                sendEmail: courseData.sendEmail,
                                                courseId:
                                                  courseData.courseSecondId,
                                                jointCourseId:
                                                  courseData.jointCourseSecondId,
                                                course: "second",
                                                bankruptcycasenum:
                                                  courseData.bankruptcycasenum,
                                                email:
                                                  response.deliverymethod ==
                                                  "E-mail"
                                                    ? response.email
                                                    : "",
                                                attyemail: response.attypref
                                                  ? response.attyemail
                                                  : "",
                                              });
                                            }
                                          } else {
                                            toast.error(
                                              "Judicial District is required"
                                            );
                                          }
                                        }}
                                        disabled={
                                          generatingSecondJoint ||
                                          generatingSecond
                                        }
                                      >
                                        {/* <FaFileAlt size={16} /> */}
                                       <img
                                    src={generateIcon}
                                    alt="generate"
                                    style={{ width: 18, height: 18 }}
                                  />
                                        {generatingSecondJoint ? (
                                          <ThreeDots
                                            height="20"
                                            width="160"
                                            radius="9"
                                            color="#FDE47F"
                                            ariaLabel="three-dots-loading"
                                            wrapperStyle={{
                                              display: "block",
                                            }}
                                            wrapperClassName="spinner"
                                            visible={true}
                                          />
                                        ) : (
                                          "Generate DE Certificate"
                                        )}
                                      </button>
                                    )}
                                  {values.courseSecondEnrol &&
                                    courseData.jointCourseSecondGenerated ==
                                      "yes" &&
                                    (courseData.jointCourseSecondDownloaded &&
                                    courseData.jointCourseSecondDownloaded !==
                                      "" ? (
                                      <a
                                        href={
                                          courseData.jointCourseSecondDownloaded
                                        }
                                        target="_blank"
                                        style={{
                                          display: "inline-block",
                                        }}
                                      >
                                        <button
                                          className="view-certificate-btn "
                                          type="button"
                                        >
                                          <FaEye size={16} />
                                          View DE Certificate
                                        </button>
                                      </a>
                                    ) : (
                                      <button
                                        className="view-certificate-btn  tooltips"
                                        type="button"
                                      >
                                        <FaEye size={16} />
                                        View DE Certificate
                                      </button>
                                    ))}
                                {/* </div> */}
                              </div>
                              {/* {values.courseSecondEnrol && certificateCounts?.DEJointCount > 0 && (
                              <div className="col-lg-6">
                                <div
                                  style={{
                                    marginTop: "10px",
                                    backgroundColor: "#f1fdf6",
                                    border: "1px solid #28a745",
                                    borderRadius: "8px",
                                    padding: "8px 12px",
                                    fontWeight: "600",
                                    color: "#155724",
                                    textAlign: "center",
                                    width: "fit-content",
                                  }}
                                >
                                  Certificates:{" "}
                                  <span style={{ color: "#28a745", fontSize: "16px" }}>
                                    {certificateCounts?.DEJointCount}
                                  </span>
                                </div>
                              </div>
                            )} */}
                              <div className="col-lg-12 mt-4">
                                <div className="col-lg-12">
                                  {values.courseSecondEnrol &&
                                    courseData.jointCourseSecondGenerated && (
                                      <div
                                        className=" input_wrap"
                                        style={{ marginBottom: "30px" }}
                                      >
                                        <label className="label-title">
                                          DE Date
                                        </label>
                                        <input
                                          type="text"
                                          readOnly
                                          className="form-control"
                                          value={
                                            courseData?.jointCourseSecondDate?.split(
                                              "T"
                                            )[0] ?? ""
                                          }
                                        />
                                        {errors.start && touched.start ? (
                                          <p className="text-danger">
                                            {errors.start}
                                          </p>
                                        ) : null}
                                      </div>
                                    )}
                                </div>
                                {values.courseSecondEnrol && (
                                  <div className="col-lg-12">
                                    <div className="certificate-upload-section">
                                      <div
                                        className=" input_wrap d-flex"
                                        style={{ marginBottom: "30px" }}
                                      >
                                        <label className="label-title">
                                          DE Cert
                                        </label>
                                        <div className="file-uplaod form-control">
                                          <input
                                            type="file"
                                            className="form-control"
                                            disabled={uploadingSecondJoint}
                                            onChange={(e) => {
                                              // setSecondPDFJoint(e.target.files[0]);
                                              const file = e.target.files[0];
                                              if (file) {
                                                setSecondPDFJoint(file);
                                                setUploadingSecondJoint(true);
                                                uploadCertificate(
                                                  "second",
                                                  {
                                                    courseId:
                                                      courseData.jointCourseSecondId,
                                                    course: "second",
                                                    email:
                                                      response.deliverymethod ==
                                                      "E-mail"
                                                        ? response.email
                                                        : "",
                                                    attyemail: response.attypref
                                                      ? response.attyemail
                                                      : "",
                                                    file: file,
                                                  },
                                                  true
                                                );
                                              }
                                            }}
                                          />
                                          {secondPDFJoint ? (
                                            secondPDFJoint.name
                                          ) : (
                                            <>
                                              {" "}
                                              <p>No file selected...</p>
                                              <span> Brows...</span>
                                            </>
                                          )}
                                          <span className="certificate-icon-inside">
                                            {uploadingSecondJoint ? (
                                              <ThreeDots
                                                height="30"
                                                width="40"
                                                radius="9"
                                                color="#4fa94d"
                                                ariaLabel="three-dots-loading"
                                                visible={true}
                                              />
                                            ) : (
                                              <FiUpload
                                                size={18}
                                                color="#4fa94d"
                                              />
                                            )}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <div style={{ display: "flex" }}>
                                      <div className="col-lg-6 ">
                                        <div
                                          className="form-text"
                                          style={{
                                            // display: "flex",
                                            // alignItems: "flex-start",
                                            marginTop: "0",
                                            // alignItems:'center'
                                          }}
                                        >
                                          {/* <button
                                        className="btn_brnd"
                                        type="button"
                                        disabled={
                                          uploadingSecondJoint ||
                                          !secondPDFJoint
                                        }
                                        onClick={() => {
                                          setUploadingSecondJoint(true);
                                          uploadCertificate(
                                            "second",
                                            {
                                              courseId:
                                                courseData.jointCourseSecondId,
                                              course: "second",
                                              email:
                                                response.deliverymethod ==
                                                  "E-mail"
                                                  ? response.email
                                                  : "",
                                              attyemail: response.attypref
                                                ? response.attyemail
                                                : "",
                                              file: secondPDFJoint,
                                            },
                                            true
                                          );
                                        }}
                                      >
                                        {uploadingSecondJoint ? (
                                          <ThreeDots
                                            height="20"
                                            width="150"
                                            radius="9"
                                            color="#4fa94d"
                                            ariaLabel="three-dots-loading"
                                            wrapperStyle={{
                                              display: "block",
                                            }}
                                            wrapperClassName="spinner"
                                            visible={true}
                                          />
                                        ) : (
                                          "Upload DE Certificate"
                                        )}
                                      </button> */}

                                          {values.courseSecondEnrol &&
                                            courseData.jointCourseSecondGenerated ==
                                              "yes" &&
                                            courseData.jointCourseSecondDownloaded &&
                                            courseData.jointCourseSecondDownloaded !==
                                              "" && (
                                              <span
                                                // className="btn_brnd "
                                                // type="button"
                                                style={{
                                                  color: "#4e9c4b",
                                                  fontSize: "16px",
                                                  fontWeight: "600",
                                                  textDecorationLine:
                                                    "underline",
                                                  // width: "40%",
                                                  cursor: "pointer",
                                                }}
                                                disabled={
                                                  resendingSecondJointToUser
                                                }
                                                onClick={() => {
                                                  setResendingSecondJointToUser(
                                                    true
                                                  );
                                                  resendCertificate(
                                                    {
                                                      firstName:
                                                        values.joint_firstname,
                                                      lastName:
                                                        values.joint_lastname,
                                                      link: courseData.jointCourseSecondDownloaded,
                                                      email: values.email,
                                                      userid: userId,
                                                      course: "DE",
                                                      type: "Joint",
                                                      //       attyEmail: values.attyemail,
                                                      // secondaryEmail: secEmails
                                                    },
                                                    setResendingSecondJointToUser
                                                  );
                                                }}
                                              >
                                                {resendingSecondJointToUser ? (
                                                  <span className="resend-btn">
                                                    <ThreeDots
                                                      height="20"
                                                      width="120"
                                                      radius="9"
                                                      color="#4fa94d"
                                                      ariaLabel="three-dots-loading"
                                                      wrapperStyle={{
                                                        display: "block",
                                                      }}
                                                      wrapperClassName="spinner"
                                                      visible={true}
                                                    />
                                                  </span>
                                                ) : (
                                                  "Resend To User"
                                                )}
                                              </span>
                                            )}
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div
                                          className="form-text"
                                          style={{
                                            // display: "flex",
                                            // alignItems: "flex-start",
                                            marginTop: "0",
                                            // alignItems:'center'
                                          }}
                                        >
                                          {values.courseSecondEnrol &&
                                            courseData.jointCourseSecondGenerated ==
                                              "yes" &&
                                            courseData.jointCourseSecondDownloaded &&
                                            courseData.jointCourseSecondDownloaded !==
                                              "" && (
                                              <span
                                                // className="btn_brnd "
                                                // type="button"
                                                style={{
                                                  color: "#4e9c4b",
                                                  fontSize: "16px",
                                                  fontWeight: "600",
                                                  textDecorationLine:
                                                    "underline",
                                                  // width: "40%",
                                                  cursor: "pointer",
                                                }}
                                                disabled={
                                                  resendingSecondJointToAttorney
                                                }
                                                onClick={() => {
                                                  setResendingSecondJointToAttorney(
                                                    true
                                                  );
                                                  resendCertificateToAttorney(
                                                    buildAttorneyResendPayload({
                                                      firstName:
                                                        values.joint_firstname,
                                                      lastName:
                                                        values.joint_lastname,
                                                      link: courseData.jointCourseSecondDownloaded,
                                                      attyEmail:
                                                        values.attyemail,
                                                      course: "DE",
                                                      type: "Joint",
                                                    }),
                                                    setResendingSecondJointToAttorney
                                                  );
                                                }}
                                              >
                                                {resendingSecondJointToAttorney ? (
                                                  <span className="resend-btn">
                                                    <ThreeDots
                                                      height="20"
                                                      width="120"
                                                      radius="9"
                                                      color="#4fa94d"
                                                      ariaLabel="three-dots-loading"
                                                      wrapperStyle={{
                                                        display: "block",
                                                      }}
                                                      wrapperClassName="spinner"
                                                      visible={true}
                                                    />
                                                  </span>
                                                ) : (
                                                  "Resend To Attorney"
                                                )}
                                              </span>
                                            )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </>
                          )}
                          {values.courseSecondEnrol && (
                            <div class="col-lg-12 mt-5">
                              <div
                                className="btn_wrap "
                                style={{ textAlign: "center" }}
                              >
                                <button
                                  type="button"
                                  className=" btn_brnd"
                                  // data-bs-toggle="modal"
                                  // data-bs-target="#nonSerious"

                                  disabled={cancelEnrollLoader}
                                  style={{ padding: "10px 18px" }}
                                  // onClick={()=>handleUnEnroll(values.id,"second",setValues,values)}
                                  onClick={() => {
                                    setCancelEnrollData({
                                      // value:'first',
                                      id: values.id,
                                      cource: "second",
                                    });
                                    console.log("values.id", values.id);

                                    setIsModal(true);
                                    // handleUnEnroll(values.id,"first",setValues,values)
                                  }}
                                >
                                  Cancel Enrollment DE
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      {/* <div
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-hidden="true"
      className={`modal ${isModal !== "" ? "show" : ""} fade custom_modal `}
      style={{
        display: isModal !== "" ? "block" : "none",
        background: "rgba(0,0,0,0.5)",
      }}
    
              >
                <div className="modal-dialog">
                  <div className="modal-content pb-60">
                    <button
                      type="button"
                      className="btn_close"
                      data-bs-dismiss="modal"
                      onClick={() => {
                        setIsModal(false);
                      }}
                    >
                      <img src={cross} alt="cross" className="cross_btn" />
                    </button>
                    <div className="modal-body">
                      <div className="modal_content">
                        <p className="f-16 text-center mt-12 fw-700">
                          Are You sure!
                        </p>

                        <div className="btn_wrap text-center mt-40">
                          <button
                            className="btn_brnd-outline mr-22 mb-2"
                            data-bs-dismiss="modal"
                            type="button"
                            onClick={() => {
                              setIsModal(false);
                            }}
                          >
                           Cancel
                          </button>

                          <button
                            className="btn_brnd"
                            // data-bs-toggle="modal"
                            // data-bs-target="#Serious"
                             type="button"
                            onClick={()=>handleUnEnroll(setValues,values)}
                          >
                            {cancelEnrollLoader || cancelEnrollLoaderFirst? (
                  <ThreeDots
                    height="20"
                    width="150"
                    radius="9"
                    color="#4fa94d"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{
                      display: "block",
                    }}
                    wrapperClassName="spinner"
                    visible={true}
                  />
                ) : (
                  "Confirm"
                )}
                             
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
                      {isModal && (
                        <div
                          data-bs-backdrop="static"
                          data-bs-keyboard="false"
                          tabIndex="-1"
                          aria-hidden="true"
                          className={`modal ${
                            isModal !== "" ? "show" : ""
                          } fade custom_modal `}
                          style={{
                            display: isModal !== "" ? "block" : "none",
                            background: "rgba(0,0,0,0.5)",
                          }}
                        >
                          <div className="modal-dialog">
                            <div
                              className="modal-content"
                              style={{ maxWidth: "600px", margin: "0px auto" }}
                            >
                              <button
                                type="button"
                                className="btn_close"
                                data-bs-dismiss="modal"
                                onClick={() => {
                                  setIsModal(false);
                                }}
                                disabled={
                                  cancelEnrollLoader || cancelEnrollLoaderFirst
                                }
                              >
                                <img
                                  src={cross}
                                  alt="cross"
                                  className="cross_btn"
                                />
                              </button>
                              <div className="modal-body">
                                <div className="modal_content">
                                  <h1 className="f-26 text-center">
                                    Are you{" "}
                                    <span className="text_success">sure</span> ?
                                  </h1>
                                  <p className="f-16 text-center mt-12">
                                    Do you really want to cancel Enrollment?
                                  </p>
                                  <div className="btn_wrap text-center">
                                    <button
                                      className="btn_brnd"
                                      type="button"
                                      onClick={() => {
                                        setIsModal(false);
                                      }}
                                      disabled={
                                        cancelEnrollLoader ||
                                        cancelEnrollLoaderFirst
                                      }
                                      style={{ marginRight: "1rem" }}
                                    >
                                      Cancel
                                    </button>
                                    <button
                                      className={`btn_brnd btn_delete `}
                                      // disabled={loading}
                                      type="button"
                                      onClick={() =>
                                        handleUnEnroll(setValues, values)
                                      }
                                    >
                                      {cancelEnrollLoader ||
                                      cancelEnrollLoaderFirst ? (
                                        <ThreeDots
                                          height="20"
                                          width="150"
                                          radius="9"
                                          color="#4fa94d"
                                          ariaLabel="three-dots-loading"
                                          wrapperStyle={{
                                            display: "block",
                                          }}
                                          wrapperClassName="spinner"
                                          visible={true}
                                        />
                                      ) : (
                                        "Confirm"
                                      )}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row mt-5">
                    <div className="client-head">
                      <div className="row align-items-center">
                        <div className="col-lg-12">
                          <h1>Re-Take courses</h1>
                        </div>
                      </div>
                    </div>

                    <div
                      className="col-lg-6"
                      style={{
                        border: "1px solid #D4D6D7",
                        borderRadius: "24px",
                        padding: "25px 35px",
                      }}
                    >
                      <div className="row">
                        <div
                          className="client-head"
                          style={{
                            backgroundColor: "transparent",
                            marginBottom: "20px",
                            // marginTop: "-30px",
                            padding: "10px 0px",
                          }}
                        >
                          <div className="row align-items-center">
                            <div className="col-lg-12">
                              <div class="row">
                                <div class="col-lg-5">
                                  <h1>Credit Counseling</h1>
                                </div>
                                {values.courseFirstEnrol &&
                                  values.course_first_retake == "1" && (
                                    <div
                                      className="col-lg-7"
                                      style={{
                                        display: "flex",
                                        justifyContent: "end",
                                      }}
                                    >
                                      <Link
                                        to={`/courseprogress?id=${userId}&course=first&retake=true`}
                                        // className="ms-4"
                                        style={{
                                          color: "#4e9c4b",
                                          fontSize: "16px",
                                          fontWeight: "600",
                                          textDecorationLine: "underline",
                                          // width: "40%",
                                        }}
                                      >
                                        {/* <button type="button" className="btn_brnd">
                                      Course Progress
                                    </button> */}
                                        Course Progress
                                      </Link>
                                    </div>
                                  )}
                              </div>
                            </div>
                          </div>
                        </div>
                        {values.course_first_retake !== "1" ? (
                          <div className="col-lg-6 mb-20">
                            <button
                              className="btn_brnd"
                              type="button"
                              onClick={() => {
                                setReTakingCC(true);
                                reTakeCC();
                              }}
                              disabled={reTakingCC}
                            >
                              {reTakingCC ? (
                                <ThreeDots
                                  height="20"
                                  width="100"
                                  radius="9"
                                  color="#4fa94d"
                                  ariaLabel="three-dots-loading"
                                  wrapperStyle={{
                                    display: "block",
                                  }}
                                  wrapperClassName="spinner"
                                  visible={true}
                                />
                              ) : (
                                "Re-Take"
                              )}
                            </button>
                          </div>
                        ) : (
                          <>
                            {/* <div className="iagree_radio mb-4">
                              {values.courseFirstEnrol ? (
                                <></>
                                <div className="mt-4 mb-4 flex">
                                  <Link
                                    to={`/user-first-course?id=${userId}&retake=true`}
                                  >
                                    <button className="btn_brnd">
                                      Continue Course
                                    </button>
                                  </Link>
                                  <Link
                                    to={`/courseprogress?id=${userId}&course=first&retake=true`}
                                    className="ms-4"
                                  >
                                    <button type="button" className="btn_brnd">
                                      Course Progress
                                    </button>
                                  </Link>
                                </div>
                              ) : (
                                <></>
                              )}
                            </div> */}
                            <div
                              className="col-lg-12 "
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "20px",
                                marginTop: ".5rem",
                              }}
                            >
                              {values.courseFirstEnrol && (
                                // <div className="col-lg-5 fw-bold">
                                <h5
                                  style={{
                                    fontWeight: "600",
                                    fontSize: "17px",
                                    marginBottom: "0",
                                  }}
                                >
                                  Main Filer
                                  <span style={{ fontSize: "14px" }}>
                                    {" "}
                                    (
                                    {retakecourseData?.perFirstCourseMain?.toFixed(
                                      0
                                    )}
                                    % Completed)
                                  </span>
                                </h5>
                                // </div>
                              )}
                              {/* <div className="col-lg-6"> */}
                                {values.courseFirstEnrol &&
                                  retakecourseData?.courseFirstGenerated ==
                                    "" && (
                                    <button
                                      type="button"
                                      className="view-certificate-btn mb-2"
                                      onClick={() => {
                                        if (values.judicialdistrict_first) {
                                          setGeneratingFirstRetake(true);

                                          if (
                                            response.judicialdistrict_first !==
                                            values.judicialdistrict_first
                                          ) {
                                            setPostLoading(true);
                                            updateProfile(userId, values)
                                              .then((res) => {
                                                toast.success(
                                                  "User updated successfully"
                                                );
                                                setPostLoading(false);
                                                generateCertificateRetake(
                                                  {
                                                    courseMainId:
                                                      retakecourseData?.courseFirstId,
                                                    courseJointId:
                                                      retakecourseData?.jointCourseFirstId,
                                                    main: true,
                                                    joint:
                                                      retakecourseData?.perFirstCourseJoint ===
                                                      100,
                                                    course: "first",
                                                    email:
                                                      response.deliverymethod ==
                                                      "E-mail"
                                                        ? response.email
                                                        : "",
                                                    attyemail: response.attypref
                                                      ? response.attyemail
                                                      : "",
                                                  },
                                                  false
                                                );
                                              })
                                              .catch((err) => {
                                                toast.error(
                                                  err.response.data.error
                                                );
                                                setPostLoading(false);
                                              });
                                          } else {
                                            generateCertificateRetake(
                                              {
                                                courseMainId:
                                                  retakecourseData?.courseFirstId,
                                                courseJointId:
                                                  retakecourseData?.jointCourseFirstId,
                                                course: "first",
                                                main: true,
                                                joint:
                                                  retakecourseData?.perFirstCourseJoint ===
                                                  100,
                                                email:
                                                  response.deliverymethod ==
                                                  "E-mail"
                                                    ? response.email
                                                    : "",
                                                attyemail: response.attypref
                                                  ? response.attyemail
                                                  : "",
                                              },
                                              false
                                            );
                                          }
                                        } else {
                                          toast.error(
                                            "Judicial District is required"
                                          );
                                        }
                                      }}
                                      disabled={
                                        generatingFirstRetake ||
                                        generatingFirstJointRetake
                                      }
                                    >
                                      {/* <FaFileAlt size={16} /> */}
                                      <img
                                    src={generateIcon}
                                    alt="generate"
                                    style={{ width: 18, height: 18 }}
                                  />
                                      {generatingFirstRetake ? (
                                        <ThreeDots
                                          height="20"
                                          width="160"
                                          radius="9"
                                          color="#FDE47F"
                                          ariaLabel="three-dots-loading"
                                          wrapperStyle={{
                                            display: "block",
                                          }}
                                          wrapperClassName="spinner"
                                          visible={true}
                                        />
                                      ) : (
                                        "Generate CC Certificate"
                                      )}
                                    </button>
                                  )}
                                {values.courseFirstEnrol &&
                                  retakecourseData?.courseFirstGenerated ==
                                    "yes" &&
                                  (retakecourseData?.courseFirstDownloaded &&
                                  retakecourseData?.courseFirstDownloaded !==
                                    "" ? (
                                    <a
                                      className="text-inherit"
                                      href={
                                        retakecourseData?.courseFirstDownloaded
                                      }
                                      target="_blank"
                                      style={{
                                        display: "inline-block",
                                      }}
                                    >
                                      <button
                                        className="view-certificate-btn "
                                        type="button"
                                      >
                                        <FaEye size={16} />
                                        View CC Certificate
                                      </button>
                                    </a>
                                  ) : (
                                    <button
                                      className="view-certificate-btn  tooltips"
                                      type="button"
                                    >
                                      <FaEye size={16} />
                                      View CC Certificate
                                    </button>
                                  ))}
                              {/* </div> */}
                            </div>
                            {/* {values.courseFirstEnrol && retakeCertificateCounts?.CCMainCount > 0 && (
                              <div className="col-lg-6">
                                <div
                                  style={{
                                    marginTop: "10px",
                                    backgroundColor: "#f1fdf6",
                                    border: "1px solid #28a745",
                                    borderRadius: "8px",
                                    padding: "8px 12px",
                                    fontWeight: "600",
                                    color: "#155724",
                                    textAlign: "center",
                                    width: "fit-content",
                                  }}
                                >d
                                  Certificates:{" "}
                                  <span style={{ color: "#28a745", fontSize: "16px" }}>
                                    {retakeCertificateCounts?.CCMainCount}
                                  </span>
                                </div>
                              </div>
                            )} */}
                            <div className="col-lg-12 mt-4">
                              <div className="col-lg-12">
                                {values.courseFirstEnrol &&
                                  retakecourseData?.courseFirstGenerated ==
                                    "yes" && (
                                    <div
                                      className=" input_wrap"
                                      style={{ marginBottom: "30px" }}
                                    >
                                      <label className="label-title">
                                        CC Date
                                      </label>
                                      <input
                                        type="text"
                                        readOnly
                                        className="form-control"
                                        value={
                                          retakecourseData?.courseFirstDate?.split(
                                            "T"
                                          )[0] ?? ""
                                        }
                                      />
                                      {errors.start && touched.start ? (
                                        <p className="text-danger">
                                          {errors.start}
                                        </p>
                                      ) : null}
                                    </div>
                                  )}
                              </div>
                              {values.courseFirstEnrol && (
                                <div className="col-lg-12 certificate-upload-section">
                                  <div
                                    className=" input_wrap d-flex"
                                    style={{ marginBottom: "30px" }}
                                  >
                                    <label className="label-title">
                                      CC Cert
                                    </label>
                                    <div className="file-uplaod form-control">
                                      <input
                                        type="file"
                                        className="form-control"
                                        disabled={uploadingFirstRetake}
                                        onChange={(e) => {
                                          // setFirstPDFRetake(e.target.files[0]);

                                          const file = e.target.files[0];
                                          if (file) {
                                            setFirstPDFRetake(file);
                                            setUploadingFirstRetake(true);
                                            uploadCertificateRetake(
                                              "first",
                                              {
                                                courseId:
                                                  retakecourseData?.courseFirstId,
                                                course: "first",
                                                email:
                                                  response.deliverymethod ==
                                                  "E-mail"
                                                    ? response.email
                                                    : "",
                                                attyemail: response.attypref
                                                  ? response.attyemail
                                                  : "",
                                                file: file,
                                              },
                                              false
                                            );
                                          }
                                        }}
                                      />
                                      {firstPDFRetake ? (
                                        firstPDFRetake.name
                                      ) : (
                                        <>
                                          {" "}
                                          <p>No file selected...</p>
                                          <span> Brows...</span>
                                        </>
                                      )}
                                      <span className="certificate-icon-inside">
                                        {uploadingFirstRetake ? (
                                          <ThreeDots
                                            height="30"
                                            width="40"
                                            radius="9"
                                            color="#4fa94d"
                                            ariaLabel="three-dots-loading"
                                            visible={true}
                                          />
                                        ) : (
                                          <FiUpload size={18} color="#4fa94d" />
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="col-lg-12  w-100">
                                    <div
                                      className="form-text"
                                      style={{
                                        display: "flex",
                                        // alignItems: "flex-start",
                                        justifyContent: "space-between",
                                        marginTop: "0",
                                        alignItems: "center",
                                      }}
                                    >
                                      {/* <button
                                        className="btn_brnd"
                                        type="button"
                                        disabled={
                                          uploadingFirstRetake ||
                                          !firstPDFRetake
                                        }
                                        onClick={() => {
                                          setUploadingFirstRetake(true);
                                          uploadCertificateRetake(
                                            "first",
                                            {
                                              courseId:
                                                retakecourseData?.courseFirstId,
                                              course: "first",
                                              email:
                                                response.deliverymethod ==
                                                  "E-mail"
                                                  ? response.email
                                                  : "",
                                              attyemail: response.attypref
                                                ? response.attyemail
                                                : "",
                                              file: firstPDFRetake,
                                            },
                                            false
                                          );
                                        }}
                                      >
                                        {uploadingFirstRetake ? (
                                          <ThreeDots
                                            height="20"
                                            width="150"
                                            radius="9"
                                            color="#4fa94d"
                                            ariaLabel="three-dots-loading"
                                            wrapperStyle={{
                                              display: "block",
                                            }}
                                            wrapperClassName="spinner"
                                            visible={true}
                                          />
                                        ) : (
                                          "Upload CC Certificate"
                                        )}
                                      </button> */}
                                      <div className="col-lg-4">
                                        {values.courseFirstEnrol &&
                                          retakecourseData?.courseFirstGenerated ==
                                            "yes" &&
                                          retakecourseData?.courseFirstDownloaded &&
                                          retakecourseData?.courseFirstDownloaded !==
                                            "" && (
                                            <span
                                              // className="btn_brnd"
                                              // type="button"
                                              style={{
                                                color: "#4e9c4b",
                                                fontSize: "16px",
                                                fontWeight: "600",
                                                textDecorationLine: "underline",
                                                // width: "40%",
                                                cursor: "pointer",
                                              }}
                                              disabled={
                                                resendingFirstRetakeToUser
                                              }
                                              onClick={() => {
                                                setResendingFirstRetakeToUser(
                                                  true
                                                );
                                                resendCertificateRetake(
                                                  {
                                                    firstName: values.firstname,
                                                    lastName: values.lastname,
                                                    link: retakecourseData?.courseFirstDownloaded,
                                                    email: values.email,
                                                    userid: userId,
                                                    course: "CC",
                                                    type: "Main",
                                                    //     attyEmail: values.attyemail,
                                                    // secondaryEmail: secEmails
                                                  },
                                                  setResendingFirstRetakeToUser
                                                );
                                              }}
                                            >
                                              {resendingFirstRetakeToUser ? (
                                                <span className="resend-btn">
                                                  <ThreeDots
                                                    height="20"
                                                    width="120"
                                                    radius="9"
                                                    color="#4fa94d"
                                                    ariaLabel="three-dots-loading"
                                                    wrapperStyle={{
                                                      display: "block",
                                                    }}
                                                    wrapperClassName="spinner"
                                                    visible={true}
                                                  />
                                                </span>
                                              ) : (
                                                "Resend To User"
                                              )}
                                            </span>
                                          )}
                                      </div>
                                      <div
                                        className="col-lg-4"
                                        style={{ textAlign: "center" }}
                                      >
                                        {values.courseFirstEnrol &&
                                          retakecourseData?.courseFirstGenerated ==
                                            "yes" &&
                                          retakecourseData?.courseFirstDownloaded &&
                                          retakecourseData?.courseFirstDownloaded !==
                                            "" && (
                                            <span
                                              // className="btn_brnd"
                                              // type="button"
                                              style={{
                                                color: "#4e9c4b",
                                                fontSize: "16px",
                                                fontWeight: "600",
                                                textDecorationLine: "underline",
                                                // width: "40%",
                                                cursor: "pointer",
                                              }}
                                              disabled={
                                                resendingFirstRetakeToAttorney
                                              }
                                              onClick={() => {
                                                setResendingFirstRetakeToAttorney(
                                                  true
                                                );
                                                resendCertificateRetakeToAttorney(
                                                  buildAttorneyResendPayload({
                                                    firstName: values.firstname,
                                                    lastName: values.lastname,
                                                    link: retakecourseData?.courseFirstDownloaded,
                                                    attyEmail: values.attyemail,
                                                    course: "CC",
                                                    type: "Main",
                                                  }),
                                                  setResendingFirstRetakeToAttorney
                                                );
                                              }}
                                            >
                                              {resendingFirstRetakeToAttorney ? (
                                                <span className="resend-btn">
                                                  <ThreeDots
                                                    height="20"
                                                    width="120"
                                                    radius="9"
                                                    color="#4fa94d"
                                                    ariaLabel="three-dots-loading"
                                                    wrapperStyle={{
                                                      display: "block",
                                                    }}
                                                    wrapperClassName="spinner"
                                                    visible={true}
                                                  />
                                                </span>
                                              ) : (
                                                "Resend To Attorney"
                                              )}
                                            </span>
                                          )}
                                      </div>
                                      <div
                                        className="col-lg-4"
                                        style={{ textAlign: "end" }}
                                      >
                                        {values.courseFirstEnrol && (
                                          <Link
                                            to={`/user-first-course?id=${userId}&retake=true`}
                                            style={{
                                              color: "#4e9c4b",
                                              fontSize: "16px",
                                              fontWeight: "600",
                                              textDecorationLine: "underline",
                                              // width: "40%",
                                            }}
                                          >
                                            {/* <button className="btn_brnd">
                                      Continue Course
                                    </button> */}
                                            Continue Course
                                          </Link>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>

                            {values.joint_username && (
                              <>
                                <div
                                  className="col-lg-12 "
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "20px",
                                    marginTop: "2.5rem",
                                  }}
                                >
                                  {values.courseFirstEnrol && (
                                    // <div className="col-lg-12 fw-bold">
                                    <h5
                                      style={{
                                        fontWeight: "600",
                                        fontSize: "17px",
                                        marginBottom: "0",
                                      }}
                                    >
                                      Joint Filer{" "}
                                      <span style={{ fontSize: "14px" }}>
                                        {" "}
                                        (
                                        {retakecourseData?.perFirstCourseJoint &&
                                          retakecourseData?.perFirstCourseJoint.toFixed(
                                            0
                                          )}
                                        % Completed)
                                      </span>
                                    </h5>
                                    // </div>
                                  )}
                                  {/* <div className="col-lg-6"> */}
                                    {values.courseFirstEnrol &&
                                      retakecourseData?.jointCourseFirstGenerated ==
                                        "" && (
                                        <button
                                          type="button"
                                          className="view-certificate-btn"
                                          onClick={() => {
                                            if (values.judicialdistrict_first) {
                                              setGeneratingFirstJointRetake(
                                                true
                                              );

                                              if (
                                                response.judicialdistrict_first !==
                                                values.judicialdistrict_first
                                              ) {
                                                setPostLoading(true);
                                                updateProfile(userId, values)
                                                  .then((res) => {
                                                    toast.success(
                                                      "User updated successfully"
                                                    );
                                                    setPostLoading(false);
                                                    generateCertificateRetake(
                                                      {
                                                        courseMainId:
                                                          retakecourseData?.courseFirstId,
                                                        courseJointId:
                                                          retakecourseData?.jointCourseFirstId,
                                                        main:
                                                          retakecourseData?.perFirstCourseMain ===
                                                          100,
                                                        joint: true,
                                                        course: "first",
                                                        email:
                                                          response.deliverymethod ==
                                                          "E-mail"
                                                            ? response.email
                                                            : "",
                                                        attyemail:
                                                          response.attypref
                                                            ? response.attyemail
                                                            : "",
                                                      },
                                                      true
                                                    );
                                                  })
                                                  .catch((err) => {
                                                    toast.error(
                                                      err.response.data.error
                                                    );
                                                    setPostLoading(false);
                                                  });
                                              } else {
                                                generateCertificateRetake(
                                                  {
                                                    courseMainId:
                                                      retakecourseData?.courseFirstId,
                                                    courseJointId:
                                                      retakecourseData?.jointCourseFirstId,
                                                    course: "first",
                                                    main:
                                                      retakecourseData?.perFirstCourseMain ===
                                                      100,
                                                    joint: true,
                                                    email:
                                                      response.deliverymethod ==
                                                      "E-mail"
                                                        ? response.email
                                                        : "",
                                                    attyemail: response.attypref
                                                      ? response.attyemail
                                                      : "",
                                                  },
                                                  true
                                                );
                                              }
                                            } else {
                                              toast.error(
                                                "Judicial District is required"
                                              );
                                            }
                                          }}
                                          disabled={
                                            generatingFirstJointRetake ||
                                            generatingFirstRetake
                                          }
                                        >
                                          {/* <FaFileAlt size={16} /> */}
                                          <img
                                    src={generateIcon}
                                    alt="generate"
                                    style={{ width: 18, height: 18 }}
                                  />
                                          {generatingFirstJointRetake ? (
                                            <ThreeDots
                                              height="20"
                                              width="160"
                                              radius="9"
                                              color="#FDE47F"
                                              ariaLabel="three-dots-loading"
                                              wrapperStyle={{
                                                display: "block",
                                              }}
                                              wrapperClassName="spinner"
                                              visible={true}
                                            />
                                          ) : (
                                            "Generate CC Certificate"
                                          )}
                                        </button>
                                      )}
                                    {values.courseFirstEnrol &&
                                      retakecourseData?.jointCourseFirstGenerated ==
                                        "yes" &&
                                      (retakecourseData?.jointCourseFirstDownloaded &&
                                      retakecourseData?.jointCourseFirstDownloaded !==
                                        "" ? (
                                        <a
                                          className="text-inherit"
                                          href={
                                            retakecourseData?.jointCourseFirstDownloaded
                                          }
                                          target="_blank"
                                          style={{
                                            display: "inline-block",
                                          }}
                                        >
                                          <button
                                            className="view-certificate-btn "
                                            type="button"
                                          >
                                            <FaEye size={16} />
                                            View CC Certificate
                                          </button>
                                        </a>
                                      ) : (
                                        <button
                                          className="view-certificate-btn  tooltips"
                                          type="button"
                                        >
                                          <FaEye size={16} />
                                          View CC Certificate
                                        </button>
                                      ))}
                                  {/* </div> */}
                                </div>
                                {/* {values.courseFirstEnrol && retakeCertificateCounts?.CCJointCount > 0 && (
                              <div className="col-lg-6">
                                <div
                                  style={{
                                    marginTop: "10px",
                                    backgroundColor: "#f1fdf6",
                                    border: "1px solid #28a745",
                                    borderRadius: "8px",
                                    padding: "8px 12px",
                                    fontWeight: "600",
                                    color: "#155724",
                                    textAlign: "center",
                                    width: "fit-content",
                                  }}
                                >
                                  Certificates:{" "}
                                  <span style={{ color: "#28a745", fontSize: "16px" }}>
                                    {retakeCertificateCounts?.CCJointCount}
                                  </span>
                                </div>
                              </div>
                            )} */}
                                <div className="col-lg-12 mt-4">
                                  <div className="col-lg-12">
                                    {values.courseFirstEnrol &&
                                      retakecourseData?.jointCourseFirstGenerated ==
                                        "yes" && (
                                        <div
                                          className=" input_wrap"
                                          style={{ marginBottom: "30px" }}
                                        >
                                          <label className="label-title">
                                            CC Date
                                          </label>
                                          <input
                                            type="text"
                                            readOnly
                                            className="form-control"
                                            value={
                                              retakecourseData?.jointCourseFirstDate?.split(
                                                "T"
                                              )[0] ?? ""
                                            }
                                          />
                                          {errors.start && touched.start ? (
                                            <p className="text-danger">
                                              {errors.start}
                                            </p>
                                          ) : null}
                                        </div>
                                      )}
                                  </div>
                                  {values.courseFirstEnrol && (
                                    <div className="col-lg-12 certificate-upload-section">
                                      <div
                                        className=" input_wrap d-flex"
                                        style={{ marginBottom: "30px" }}
                                      >
                                        <label className="label-title">
                                          CC Cert
                                        </label>
                                        <div className="file-uplaod form-control">
                                          <input
                                            type="file"
                                            className="form-control"
                                            disabled={uploadingFirstJointRetake}
                                            onChange={(e) => {
                                              // setFirstPDFJointRetake(
                                              //   e.target.files[0]
                                              // );

                                              const file = e.target.files[0];
                                              if (file) {
                                                setFirstPDFJointRetake(file);
                                                setUploadingFirstJointRetake(
                                                  true
                                                );
                                                uploadCertificateRetake(
                                                  "first",
                                                  {
                                                    courseId:
                                                      retakecourseData?.jointCourseFirstId,
                                                    course: "first",
                                                    email:
                                                      response.deliverymethod ==
                                                      "E-mail"
                                                        ? response.email
                                                        : "",
                                                    attyemail: response.attypref
                                                      ? response.attyemail
                                                      : "",
                                                    file: file,
                                                  },
                                                  true
                                                );
                                              }
                                            }}
                                          />
                                          {firstPDFJointRetake ? (
                                            firstPDFJointRetake.name
                                          ) : (
                                            <>
                                              {" "}
                                              <p>No file selected...</p>
                                              <span> Brows...</span>
                                            </>
                                          )}
                                          <span className="certificate-icon-inside">
                                            {uploadingFirstJointRetake ? (
                                              <ThreeDots
                                                height="30"
                                                width="40"
                                                radius="9"
                                                color="#4fa94d"
                                                ariaLabel="three-dots-loading"
                                                visible={true}
                                              />
                                            ) : (
                                              <FiUpload
                                                size={18}
                                                color="#4fa94d"
                                              />
                                            )}
                                          </span>
                                        </div>
                                      </div>
                                      <div style={{ display: "flex" }}>
                                        <div className="col-lg-6  ">
                                          <div
                                            className="form-text"
                                            style={{
                                              // display: "flex",
                                              // alignItems: "flex-start",
                                              marginTop: "0",
                                              // alignItems:'center'
                                            }}
                                          >
                                            {/* <button
                                            className="btn_brnd"
                                            type="button"
                                            disabled={
                                              uploadingFirstJointRetake ||
                                              !firstPDFJointRetake
                                            }
                                            onClick={() => {
                                              setUploadingFirstJointRetake(
                                                true
                                              );
                                              uploadCertificateRetake(
                                                "first",
                                                {
                                                  courseId:
                                                    retakecourseData?.jointCourseFirstId,
                                                  course: "first",
                                                  email:
                                                    response.deliverymethod ==
                                                      "E-mail"
                                                      ? response.email
                                                      : "",
                                                  attyemail: response.attypref
                                                    ? response.attyemail
                                                    : "",
                                                  file: firstPDFJointRetake,
                                                },
                                                true
                                              );
                                            }}
                                          >
                                            {uploadingFirstJointRetake ? (
                                              <ThreeDots
                                                height="20"
                                                width="150"
                                                radius="9"
                                                color="#4fa94d"
                                                ariaLabel="three-dots-loading"
                                                wrapperStyle={{
                                                  display: "block",
                                                }}
                                                wrapperClassName="spinner"
                                                visible={true}
                                              />
                                            ) : (
                                              "Upload CC Certificate"
                                            )}
                                          </button> */}
                                            {values.courseFirstEnrol &&
                                              retakecourseData?.jointCourseFirstGenerated ==
                                                "yes" &&
                                              retakecourseData?.jointCourseFirstDownloaded &&
                                              retakecourseData?.jointCourseFirstDownloaded !==
                                                "" && (
                                                <span
                                                  // className="btn_brnd "
                                                  // type="button"
                                                  style={{
                                                    color: "#4e9c4b",
                                                    fontSize: "16px",
                                                    fontWeight: "600",
                                                    textDecorationLine:
                                                      "underline",
                                                    // width: "40%",
                                                    cursor: "pointer",
                                                  }}
                                                  disabled={
                                                    resendingFirstJointRetakeToUser
                                                  }
                                                  onClick={() => {
                                                    setResendingFirstJointRetakeToUser(
                                                      true
                                                    );
                                                    resendCertificateRetake(
                                                      {
                                                        firstName:
                                                          values.joint_firstname,
                                                        lastName:
                                                          values.joint_lastname,
                                                        link: retakecourseData?.jointCourseFirstDownloaded,
                                                        email: values.email,
                                                        userid: userId,
                                                        course: "CC",
                                                        type: "Joint",
                                                        //         attyEmail: values.attyemail,
                                                        // secondaryEmail: secEmails
                                                      },
                                                      setResendingFirstJointRetakeToUser
                                                    );
                                                  }}
                                                >
                                                  {resendingFirstJointRetakeToUser ? (
                                                    <span className="resend-btn">
                                                      <ThreeDots
                                                        height="20"
                                                        width="120"
                                                        radius="9"
                                                        color="#4fa94d"
                                                        ariaLabel="three-dots-loading"
                                                        wrapperStyle={{
                                                          display: "block",
                                                        }}
                                                        wrapperClassName="spinner"
                                                        visible={true}
                                                      />
                                                    </span>
                                                  ) : (
                                                    "Resend To User"
                                                  )}
                                                </span>
                                              )}
                                          </div>
                                        </div>
                                        <div className="col-lg-6 ">
                                          <div
                                            className="form-text"
                                            style={{
                                              // display: "flex",
                                              // alignItems: "flex-start",
                                              marginTop: "0",
                                              // alignItems:'center'
                                            }}
                                          >
                                            {values.courseFirstEnrol &&
                                              retakecourseData?.jointCourseFirstGenerated ==
                                                "yes" &&
                                              retakecourseData?.jointCourseFirstDownloaded &&
                                              retakecourseData?.jointCourseFirstDownloaded !==
                                                "" && (
                                                <span
                                                  // className="btn_brnd "
                                                  // type="button"
                                                  style={{
                                                    color: "#4e9c4b",
                                                    fontSize: "16px",
                                                    fontWeight: "600",
                                                    textDecorationLine:
                                                      "underline",
                                                    // width: "40%",
                                                    cursor: "pointer",
                                                  }}
                                                  disabled={
                                                    resendingFirstJointRetakeToAttorney
                                                  }
                                                  onClick={() => {
                                                    setResendingFirstJointRetakeToAttorney(
                                                      true
                                                    );
                                                    resendCertificateRetakeToAttorney(
                                                      buildAttorneyResendPayload({
                                                        firstName:
                                                          values.joint_firstname,
                                                        lastName:
                                                          values.joint_lastname,
                                                        link: retakecourseData?.jointCourseFirstDownloaded,
                                                        attyEmail:
                                                          values.attyemail,
                                                        course: "CC",
                                                        type: "Joint",
                                                      }),
                                                      setResendingFirstJointRetakeToAttorney
                                                    );
                                                  }}
                                                >
                                                  {resendingFirstJointRetakeToAttorney ? (
                                                    <span className="resend-btn">
                                                      <ThreeDots
                                                        height="20"
                                                        width="120"
                                                        radius="9"
                                                        color="#4fa94d"
                                                        ariaLabel="three-dots-loading"
                                                        wrapperStyle={{
                                                          display: "block",
                                                        }}
                                                        wrapperClassName="spinner"
                                                        visible={true}
                                                      />
                                                    </span>
                                                  ) : (
                                                    "Resend To Attorney"
                                                  )}
                                                </span>
                                              )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </>
                            )}
                          </>
                        )}
                        {values.course_first_retake == "1" && (
                          <div class="col-lg-12 mt-5">
                            <div
                              className="btn_wrap "
                              style={{ textAlign: "center" }}
                            >
                              {/* <span className={`${(courseData?.courseFirstGenerated == "yes" || courseData.jointCourseFirstGenerated == "yes") ? "cert-tooltip" : ""}`}> */}
                              <button
                                type="button"
                                className="btn_brnd"
                                disabled={cancelEnrollLoaderFirst}
                                style={{ padding: "10px 18px" }}
                                onClick={() => {
                                  setCancelRetakeEnrollData({
                                    // value:'first',
                                    id: values.id,
                                    cource: "first",
                                  });
                                  setIsRetakeModal(true);
                                  // handleUnEnroll(values.id,"first",setValues,values)
                                }}
                              >
                                Cancel Enrollment CC
                              </button>
                              {/* </span>    */}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {isRetakeModal && (
                      <div
                        data-bs-backdrop="static"
                        data-bs-keyboard="false"
                        tabIndex="-1"
                        aria-hidden="true"
                        className={`modal ${
                          isModal !== "" ? "show" : ""
                        } fade custom_modal `}
                        style={{
                          display: isModal !== "" ? "block" : "none",
                          background: "rgba(0,0,0,0.5)",
                        }}
                      >
                        <div className="modal-dialog">
                          <div
                            className="modal-content"
                            style={{ maxWidth: "600px", margin: "0px auto" }}
                          >
                            <button
                              type="button"
                              className="btn_close"
                              data-bs-dismiss="modal"
                              onClick={() => {
                                setIsRetakeModal(false);
                              }}
                              disabled={cancelRetakeEnrollLoader}
                            >
                              <img
                                src={cross}
                                alt="cross"
                                className="cross_btn"
                              />
                            </button>
                            <div className="modal-body">
                              <div className="modal_content">
                                <h1 className="f-26 text-center">
                                  Are you{" "}
                                  <span className="text_success">sure</span> ?
                                </h1>
                                <p className="f-16 text-center mt-12">
                                  Do you really want to cancel Enrollment?
                                </p>
                                <div className="btn_wrap text-center">
                                  <button
                                    className="btn_brnd"
                                    type="button"
                                    onClick={() => {
                                      setIsRetakeModal(false);
                                    }}
                                    disabled={cancelRetakeEnrollLoader}
                                    style={{ marginRight: "1rem" }}
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    className={`btn_brnd btn_delete `}
                                    // disabled={loading}
                                    type="button"
                                    onClick={() =>
                                      handleUnEnrollRetakeFirst(
                                        setValues,
                                        values
                                      )
                                    }
                                  >
                                    {cancelRetakeEnrollLoader ? (
                                      <ThreeDots
                                        height="20"
                                        width="150"
                                        radius="9"
                                        color="#4fa94d"
                                        ariaLabel="three-dots-loading"
                                        wrapperStyle={{
                                          display: "block",
                                        }}
                                        wrapperClassName="spinner"
                                        visible={true}
                                      />
                                    ) : (
                                      "Confirm"
                                    )}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* <div className="col-lg-6">
                      <div className="row">
                        <div
                          className="client-head"
                          style={{
                            backgroundColor: "transparent",
                            marginBottom: "20px",
                            marginTop: "-30px",
                          }}
                        >
                          <div className="row align-items-center">
                            <div className="col-lg-12">
                              <div class="row">
                                <div class="col-lg-5">
                                  <h1>Debtor Education</h1>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {values.course_second_retake !== "1" ? (
                          <div className="col-lg-6">
                            <button
                              className="btn_brnd"
                              type="button"
                              onClick={() => {
                                setReTakingDE(true);
                                reTakeDE();
                              }}
                              disabled={reTakingDE}
                            >
                              {reTakingDE ? (
                                <ThreeDots
                                  height="20"
                                  width="100"
                                  radius="9"
                                  color="#4fa94d"
                                  ariaLabel="three-dots-loading"
                                  wrapperStyle={{
                                    display: "block",
                                  }}
                                  wrapperClassName="spinner"
                                  visible={true}
                                />
                              ) : (
                                "Re-Take"
                              )}
                            </button>
                          </div>
                        ) : (
                          <>
                            <div className="iagree_radio mb-4">
                              {values.courseSecondEnrol ? (
                                <div className="mt-4 mb-4">
                                  <Link
                                    to={`/user-second-course?id=${userId}&retake=true`}
                                  >
                                    <button className="btn_brnd">
                                      Continue Course
                                    </button>
                                  </Link>
                                  <Link
                                    to={`/courseprogress?id=${userId}&course=second&retake=true`}
                                    className="ms-4"
                                  >
                                    <button type="button" className="btn_brnd">
                                      Course Progress
                                    </button>
                                  </Link>
                                </div>
                              ) : (
                                <div className="mt-4 mb-4 ">
                                  <button type="button" className="btn_brnd" disabled={enrollmentLoading} onClick={() => startEnrollment("second")}>
                                    {enrollmentLoading ? "Loading..." : "Enroll Now"}
                                  </button>
                                </div>
                              )}
                            </div>

                            {values.courseSecondEnrol && (
                              <div className="col-lg-12 fw-bold">
                                <h5
                                  style={{
                                    fontWeight: "600",
                                    fontSize: "17px",
                                  }}
                                >
                                  Main Filer{" "}
                                  <span style={{ fontSize: "14px" }}>
                                    {" "}
                                    (
                                    {retakecourseData?.perSecondCourseMain.toFixed(
                                      0
                                    )}
                                    % Completed)
                                  </span>
                                </h5>
                              </div>
                            )}
                            <div className="col-lg-6">
                              {values.courseSecondEnrol &&
                                retakecourseData?.generated == "" && (
                                  <button
                                    className="btn_brnd"
                                    type="button"
                                    onClick={() => {
                                      if (values.judicialdistrict_second) {
                                        setGeneratingSecondRetake(true);

                                        if (
                                          response.judicialdistrict_second !==
                                          values.judicialdistrict_second
                                        ) {
                                          setPostLoading(true);
                                          updateProfile(userId, values)
                                            .then((res) => {
                                              toast.success(
                                                "User updated successfully"
                                              );
                                              setPostLoading(false);
                                              generateCertificateSecondRetake({
                                                sendEmail:
                                                  retakecourseData?.sendEmail,
                                                courseId:
                                                  retakecourseData?.courseSecondId,
                                                jointCourseId:
                                                  retakecourseData?.jointCourseSecondId,
                                                course: "second",
                                                bankruptcycasenum:
                                                  values.bankruptcycasenum,
                                                email:
                                                  response.deliverymethod ==
                                                  "E-mail"
                                                    ? response.email
                                                    : "",
                                                attyemail: response.attypref
                                                  ? response.attyemail
                                                  : "",
                                              });
                                            })
                                            .catch((err) => {
                                              toast.error(
                                                err.response.data.error
                                              );
                                              setPostLoading(false);
                                            });
                                        } else {
                                          generateCertificateSecondRetake({
                                            sendEmail:
                                              retakecourseData?.sendEmail,
                                            courseId:
                                              retakecourseData?.courseSecondId,
                                            jointCourseId:
                                              retakecourseData?.jointCourseSecondId,
                                            course: "second",
                                            bankruptcycasenum:
                                              values.bankruptcycasenum,
                                            email:
                                              response.deliverymethod ==
                                              "E-mail"
                                                ? response.email
                                                : "",
                                            attyemail: response.attypref
                                              ? response.attyemail
                                              : "",
                                          });
                                        }
                                      } else {
                                        toast.error(
                                          "Judicial District is required"
                                        );
                                      }
                                    }}
                                    disabled={generatingSecondRetake}
                                  >
                                    {generatingSecondRetake ? (
                                      <ThreeDots
                                        height="20"
                                        width="160"
                                        radius="9"
                                        color="#4fa94d"
                                        ariaLabel="three-dots-loading"
                                        wrapperStyle={{
                                          display: "block",
                                        }}
                                        wrapperClassName="spinner"
                                        visible={true}
                                      />
                                    ) : (
                                      "Generate DE Certificate"
                                    )}
                                  </button>
                                )}
                              {values.courseSecondEnrol &&
                                retakecourseData?.generated == "yes" &&
                                (retakecourseData?.downloaded &&
                                retakecourseData?.downloaded !== "yes" ? (
                                  <a
                                    href={retakecourseData?.downloaded}
                                    target="_blank"
                                  >
                                    <button
                                      className="btn_brnd mt-lg-2 mb-4 mb-lg-0"
                                      type="button"
                                    >
                                      View DE Certificate
                                    </button>
                                  </a>
                                ) : (
                                  <button
                                    className="btn_brnd mt-lg-2 mb-4 mb-lg-0 tooltips"
                                    type="button"
                                  >
                                    View DE Certificate
                                  </button>
                                ))}
                            </div>
                            <div className="col-lg-12 mt-5">
                              {values.courseSecondEnrol &&
                                retakecourseData?.generated && (
                                  <div className=" input_wrap">
                                    <label className="label-title">
                                      DE Date
                                    </label>
                                    <input
                                      type="text"
                                      readOnly
                                      className="form-control"
                                      value={
                                        retakecourseData?.date?.split("T")[0] ??
                                        ""
                                      }
                                    />
                                    {errors.start && touched.start ? (
                                      <p className="text-danger">
                                        {errors.start}
                                      </p>
                                    ) : null}
                                  </div>
                                )}
                              {values.courseSecondEnrol && (
                                <div className="col-lg-12">
                                  <div className=" input_wrap d-flex">
                                    <label className="label-title">
                                      DE Cert
                                    </label>
                                    <div className="file-uplaod form-control">
                                      <input
                                        type="file"
                                        className="form-control"
                                        onChange={(e) => {
                                          setSecondPDFRetake(e.target.files[0]);
                                        }}
                                      />
                                      {secondPDFRetake ? (
                                        secondPDFRetake.name
                                      ) : (
                                        <>
                                          {" "}
                                          <p>No file selected...</p>
                                          <span> Brows...</span>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-lg-6 mb-4 w-100">
                                    <div
                                      className="form-text"
                                      style={{
                                        display: "flex",
                                        alignItems: "flex-start",
                                      }}
                                    >
                                      <button
                                        className="btn_brnd"
                                        type="button"
                                        disabled={
                                          uploadingSecondRetake ||
                                          !secondPDFRetake
                                        }
                                        onClick={() => {
                                          setUploadingSecondRetake(true);
                                          uploadCertificateRetake(
                                            "second",
                                            {
                                              courseId:
                                                retakecourseData?.courseSecondId,
                                              course: "second",
                                              email:
                                                response.deliverymethod ==
                                                "E-mail"
                                                  ? response.email
                                                  : "",
                                              attyemail: response.attypref
                                                ? response.attyemail
                                                : "",
                                              file: secondPDFRetake,
                                            },
                                            false
                                          );
                                        }}
                                      >
                                        {uploadingSecondRetake ? (
                                          <ThreeDots
                                            height="20"
                                            width="150"
                                            radius="9"
                                            color="#4fa94d"
                                            ariaLabel="three-dots-loading"
                                            wrapperStyle={{
                                              display: "block",
                                            }}
                                            wrapperClassName="spinner"
                                            visible={true}
                                          />
                                        ) : (
                                          "Upload DE Certificate"
                                        )}
                                      </button>

                                      {values.courseSecondEnrol &&
                                        retakecourseData?.generated == "yes" &&
                                        retakecourseData?.downloaded &&
                                        retakecourseData?.downloaded !==
                                          "yes" && (
                                          <button
                                            className="btn_brnd mb-4 mb-lg-0 ms-4"
                                            type="button"
                                            disabled={resendingSecondRetake}
                                            onClick={() => {
                                              setResendingSecondRetake(true);
                                              resendCertificateRetake(
                                                {
                                                  firstName: values.firstname,
                                                  lastName: values.lastname,
                                                  link: retakecourseData?.downloaded,
                                                  email: values.email,
                                                  userid: userId,
                                                  course: "DE",
                                                  type: "Main",
                                                },
                                                setResendingSecondRetake
                                              );
                                            }}
                                          >
                                            {resendingSecondRetake ? (
                                              <ThreeDots
                                                height="20"
                                                width="60"
                                                radius="9"
                                                color="#4fa94d"
                                                ariaLabel="three-dots-loading"
                                                wrapperStyle={{
                                                  display: "block",
                                                }}
                                                wrapperClassName="spinner"
                                                visible={true}
                                              />
                                            ) : (
                                              "Resend"
                                            )}
                                          </button>
                                        )}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>

                            {values.joint_username && (
                              <>
                                {values.courseSecondEnrol && (
                                  <div className="col-lg-12 fw-bold">
                                    <h5
                                      style={{
                                        fontWeight: "600",
                                        fontSize: "17px",
                                      }}
                                    >
                                      Joint Filer{" "}
                                      <span style={{ fontSize: "14px" }}>
                                        {" "}
                                        (
                                        {retakecourseData?.perSecondCourseJoint &&
                                          retakecourseData?.perSecondCourseJoint.toFixed(
                                            0
                                          )}
                                        % Completed)
                                      </span>
                                    </h5>
                                  </div>
                                )}
                                <div className="col-lg-6">
                                  {values.courseSecondEnrol &&
                                    retakecourseData?.jointCourseSecondGenerated ==
                                      "" && (
                                      <button
                                        className="btn_brnd"
                                        type="button"
                                        onClick={() => {
                                          if (values.judicialdistrict_second) {
                                            setGeneratingSecondJointRetake(
                                              true
                                            );

                                            if (
                                              response.judicialdistrict_second !==
                                              values.judicialdistrict_second
                                            ) {
                                              setPostLoading(true);
                                              updateProfile(userId, values)
                                                .then((res) => {
                                                  toast.success(
                                                    "User updated successfully"
                                                  );
                                                  setPostLoading(false);
                                                  generateCertificateSecondRetake(
                                                    {
                                                      sendEmail:
                                                        retakecourseData?.sendEmail,
                                                      courseId:
                                                        retakecourseData?.courseSecondId,
                                                      jointCourseId:
                                                        retakecourseData?.jointCourseSecondId,
                                                      course: "second",
                                                      bankruptcycasenum:
                                                        values.bankruptcycasenum,
                                                      email:
                                                        response.deliverymethod ==
                                                        "E-mail"
                                                          ? response.email
                                                          : "",
                                                      attyemail:
                                                        response.attypref
                                                          ? response.attyemail
                                                          : "",
                                                    }
                                                  );
                                                })
                                                .catch((err) => {
                                                  toast.error(
                                                    err.response.data.error
                                                  );
                                                  setPostLoading(false);
                                                });
                                            } else {
                                              generateCertificateSecondRetake({
                                                sendEmail:
                                                  retakecourseData?.sendEmail,
                                                courseId:
                                                  retakecourseData?.courseSecondId,
                                                jointCourseId:
                                                  retakecourseData?.jointCourseSecondId,
                                                course: "second",
                                                bankruptcycasenum:
                                                  values.bankruptcycasenum,
                                                email:
                                                  response.deliverymethod ==
                                                  "E-mail"
                                                    ? response.email
                                                    : "",
                                                attyemail: response.attypref
                                                  ? response.attyemail
                                                  : "",
                                              });
                                            }
                                          } else {
                                            toast.error(
                                              "Judicial District is required"
                                            );
                                          }
                                        }}
                                        disabled={generatingSecondJointRetake}
                                      >
                                        {generatingSecondJointRetake ? (
                                          <ThreeDots
                                            height="20"
                                            width="160"
                                            radius="9"
                                            color="#4fa94d"
                                            ariaLabel="three-dots-loading"
                                            wrapperStyle={{
                                              display: "block",
                                            }}
                                            wrapperClassName="spinner"
                                            visible={true}
                                          />
                                        ) : (
                                          "Generate DE Certificate"
                                        )}
                                      </button>
                                    )}
                                  {values.courseSecondEnrol &&
                                    retakecourseData?.jointCourseSecondGenerated ==
                                      "yes" &&
                                    (retakecourseData?.jointCourseSecondDownloaded &&
                                    retakecourseData?.jointCourseSecondDownloaded !==
                                      "yes" ? (
                                      <a
                                        href={
                                          retakecourseData?.jointCourseSecondDownloaded
                                        }
                                        target="_blank"
                                      >
                                        <button
                                          className="btn_brnd mt-lg-2 mb-4 mb-lg-0"
                                          type="button"
                                        >
                                          View DE Certificate
                                        </button>
                                      </a>
                                    ) : (
                                      <button
                                        className="btn_brnd mt-lg-2 mb-4 mb-lg-0 tooltips"
                                        type="button"
                                      >
                                        View DE Certificate
                                      </button>
                                    ))}
                                </div>
                                <div className="col-lg-12 mt-5">
                                  {values.courseSecondEnrol &&
                                    retakecourseData?.jointCourseSecondGenerated && (
                                      <div className=" input_wrap">
                                        <label className="label-title">
                                          DE Date
                                        </label>
                                        <input
                                          type="text"
                                          readOnly
                                          className="form-control"
                                          value={
                                            retakecourseData?.jointCourseSecondDate?.split(
                                              "T"
                                            )[0] ?? ""
                                          }
                                        />
                                        {errors.start && touched.start ? (
                                          <p className="text-danger">
                                            {errors.start}
                                          </p>
                                        ) : null}
                                      </div>
                                    )}
                                  {values.courseSecondEnrol && (
                                    <div className="col-lg-12">
                                      <div className=" input_wrap d-flex">
                                        <label className="label-title">
                                          DE Cert
                                        </label>
                                        <div className="file-uplaod form-control">
                                          <input
                                            type="file"
                                            className="form-control"
                                            onChange={(e) => {
                                              setSecondPDFJointRetake(
                                                e.target.files[0]
                                              );
                                            }}
                                          />
                                          {secondPDFJointRetake ? (
                                            secondPDFJointRetake.name
                                          ) : (
                                            <>
                                              {" "}
                                              <p>No file selected...</p>
                                              <span> Brows...</span>
                                            </>
                                          )}
                                        </div>
                                      </div>
                                      <div className="col-lg-6 mb-4 w-100">
                                        <div
                                          className="form-text"
                                          style={{
                                            display: "flex",
                                            alignItems: "flex-start",
                                          }}
                                        >
                                          <button
                                            className="btn_brnd"
                                            type="button"
                                            disabled={
                                              uploadingSecondJointRetake ||
                                              !secondPDFJointRetake
                                            }
                                            onClick={() => {
                                              setUploadingSecondJointRetake(
                                                true
                                              );
                                              uploadCertificateRetake(
                                                "second",
                                                {
                                                  courseId:
                                                    retakecourseData?.jointCourseSecondId,
                                                  course: "second",
                                                  email:
                                                    response.deliverymethod ==
                                                    "E-mail"
                                                      ? response.email
                                                      : "",
                                                  attyemail: response.attypref
                                                    ? response.attyemail
                                                    : "",
                                                  file: secondPDFJointRetake,
                                                },
                                                true
                                              );
                                            }}
                                          >
                                            {uploadingSecondJointRetake ? (
                                              <ThreeDots
                                                height="20"
                                                width="150"
                                                radius="9"
                                                color="#4fa94d"
                                                ariaLabel="three-dots-loading"
                                                wrapperStyle={{
                                                  display: "block",
                                                }}
                                                wrapperClassName="spinner"
                                                visible={true}
                                              />
                                            ) : (
                                              "Upload DE Certificate"
                                            )}
                                          </button>

                                          {values.courseSecondEnrol &&
                                            retakecourseData?.jointCourseSecondGenerated ==
                                              "yes" &&
                                            retakecourseData?.jointCourseSecondDownloaded &&
                                            retakecourseData?.jointCourseSecondDownloaded !==
                                              "yes" && (
                                              <button
                                                className="btn_brnd mb-4 mb-lg-0 ms-4"
                                                type="button"
                                                disabled={
                                                  resendingSecondJointRetake
                                                }
                                                onClick={() => {
                                                  setResendingSecondJointRetake(
                                                    true
                                                  );
                                                  resendCertificate(
                                                    {
                                                      firstName:
                                                        values.joint_firstname,
                                                      lastName:
                                                        values.joint_lastname,
                                                      link: retakecourseData?.jointCourseSecondDownloaded,
                                                      email: values.email,
                                                      userid: userId,
                                                      course: "DE",
                                                      type: "Joint",
                                                    },
                                                    setResendingSecondJointRetake
                                                  );
                                                }}
                                              >
                                                {resendingSecondJointRetake ? (
                                                  <ThreeDots
                                                    height="20"
                                                    width="60"
                                                    radius="9"
                                                    color="#4fa94d"
                                                    ariaLabel="three-dots-loading"
                                                    wrapperStyle={{
                                                      display: "block",
                                                    }}
                                                    wrapperClassName="spinner"
                                                    visible={true}
                                                  />
                                                ) : (
                                                  "Resend"
                                                )}
                                              </button>
                                            )}
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </>
                            )}
                          </>
                        )}
                      </div>
                    </div> */}
                  </div>

                  <div className="row mt-40">
                    <div className="client-head">
                      <div className="row align-items-center">
                        <div className="col-lg-12">
                          <h1>Address</h1>
                        </div>
                      </div>
                    </div>
                    {/* <div className="client-head">
                    <h1>Address</h1>
                  </div> */}
                    <div className="row">
                      <div className="col-lg-6">
                        <div className=" input_wrap">
                          <label className="label-title">Address Line 1</label>
                          <input
                            type="text"
                            className="form-control"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="addr1"
                            value={values.addr1}
                          />
                          {errors.addr1 && touched.addr1 ? (
                            <p className="text-danger">{errors.addr1}</p>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className=" input_wrap">
                          <label className="label-title">Address Line 2</label>
                          <input
                            type="text"
                            className="form-control"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="addr2"
                            value={values.addr2}
                          />
                          {errors.addr2 && touched.addr2 ? (
                            <p className="text-danger">{errors.addr2}</p>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className=" input_wrap">
                          <label className="label-title">City</label>
                          <input
                            type="text"
                            className="form-control"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="city"
                            value={values.city}
                          />
                          {errors.city && touched.city ? (
                            <p className="text-danger">{errors.city}</p>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className=" input_wrap">
                          <label className="label-title">State</label>
                          <input
                            type="text"
                            className="form-control"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="state"
                            value={values.state}
                          />
                          {errors.state && touched.state ? (
                            <p className="text-danger">{errors.state}</p>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className=" input_wrap">
                          <label className="label-title">Zip Code</label>
                          <input
                            type="text"
                            className="form-control"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="zip"
                            value={values.zip}
                          />
                          {errors.zip && touched.zip ? (
                            <p className="text-danger">{errors.zip}</p>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="student-certificate-section">
                    <div className="client-head">
                      <div className="row align-items-center">
                        <div className="col-lg-12">
                          <h1>Certificate Delivery Method</h1>
                        </div>
                      </div>
                    </div>
                    {/* </div> */}
                    {/* <div className="client-head">
                    <h1>Certificate Delivery Method</h1>
                  </div> */}
                    <div className="certificate-options">
                    <div className="row ">
                      <div className="col-lg-6 mb-4">
                        <label className="from-label">
                          Certificate delivery method:
                        </label>
                      </div>
                      <div className="col-lg-6 mb-4">
                        <div className="iagree_radio  form-check-inline">
                          <div>
                            <input
                              type="checkbox"
                              name="tickbox"
                              checked={values.deliverymethod === "E-mail"}
                              onChange={() => {
                                setValues({
                                  ...values,
                                  deliverymethod: "E-mail",
                                });
                              }}
                              id="email"
                              className=" "
                            />
                            <label htmlFor="email">Email</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div className="row ">
                    <div className="col-lg-6 mb-4">
                      <label className="from-label">Is This Urgent?</label>
                    </div>
                    <div className="col-lg-6 mb-4">
                      <div className="iagree_radio  form-check-inline">
                        <div>
                          <input
                            type="checkbox"
                            name="tickbox"
                            checked={values.urgent === "checked"}
                            onChange={() => {
                              setValues({
                                ...values,
                                urgent: "checked",
                              });
                            }}
                            id="urgentYes"
                            className=" "
                          />
                          <label for="urgentYes">Yes</label>
                        </div>
                      </div>
                      <div className="iagree_radio form-check-inline">
                        <div>
                          <input
                            type="checkbox"
                            name="tickbox"
                            checked={values.urgent !== "checked"}
                            onChange={() => {
                              setValues({ ...values, urgent: "" });
                            }}
                            id="urgentNo"
                            className=" "
                          />
                          <label for="urgentNo">No</label>
                        </div>
                      </div>
                    </div>
                  </div> */}
                    {/* ------------ verify button ---------- */}
                    <div className="row ">
                      <div className="col-lg-6 mb-4">
                        <label className="from-label">
                          Want us to e-mail certificate to your attorney?
                        </label>
                      </div>
                      <div className="col-lg-6 mb-4">
                        <div className="iagree_radio  form-check-inline">
                          <div>
                            <input
                              type="checkbox"
                              name="tickbox"
                              checked={values.attypref === "checked"}
                              onChange={() => {
                                setValues({ ...values, attypref: "checked" });
                              }}
                              id="attyprefYes"
                              className=" "
                            />
                            <label htmlFor="attyprefYes">Yes</label>
                          </div>
                        </div>
                        <div className="iagree_radio form-check-inline">
                          <div>
                            <input
                              type="checkbox"
                              name="tickbox"
                              id="attyprefNo"
                              checked={values.attypref !== "checked"}
                              onChange={() => {
                                setValues({ ...values, attypref: "" });
                              }}
                              className=" "
                            />
                            <label htmlFor="attyprefNo">No</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <AttorneyReferralStatus userId={userId} />
                    </div>

                    {/* ------------------------------------- attorney code row ------------------------------------- */}
                    <div className="row certificate-attorney-fields">
                      {/* ==============attorney email address */}
                      <div className="col-lg-6">
                        <div className=" input_wrap">
                          <label className="label-title" htmlFor="student-attorney-email">
                            Attorney's E-mail Address
                          </label>
                          <input
                            id="student-attorney-email"
                            type="text"
                            className="form-control"
                            readOnly={
                              values.attyemail &&
                              values.attorneyCodeExist &&
                              values.couponcode_first !== ""
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="attyemail"
                            value={values.attyemail}
                          />
                          {errors.attyemail && touched.attyemail ? (
                            <p className="text-danger">{errors.attyemail}</p>
                          ) : null}
                        </div>
                      </div>
                    </div>

                    <div className="row certificate-code-fields">
                      {/* ------------ Attorney Code [CC] ---------- */}
                      <div className="col-lg-6 certificate-code-column">
                        <div className=" input_wrap">
                          <label className="label-title" htmlFor="student-cc-code">
                            CC Code{" "}
                            {values?.activeCode &&
                              values.activeCode === "CC" &&
                              "(Active)"}
                          </label>
                          <input
                            id="student-cc-code"
                            type="text"
                            className="form-control"
                            onChange={(e) => {
                              handleChange(e);
                              setattCodeValidation(false);
                              setAllowAssociate((prev) => ({
                                ...prev,
                                CC: false,
                              }));
                            }}
                            onBlur={handleBlur}
                            name="couponcode_first"
                            value={values.couponcode_first}
                          />
                          {/* {values.couponcode_first &&
                        values.attyemail &&
                        !values.attorneyCodeExist ? (
                          <p className="text-danger">
                            Attorney code no longer supported
                          </p>
                        ) : null} */}
                          {attCodeValidation === "CC" && (
                            <p className="text-danger">
                              Invalid Attorney Code{" "}
                            </p>
                          )}
                          {errors.couponcode_first &&
                          touched.couponcode_first ? (
                            <p className="text-danger">
                              {errors.couponcode_first}
                            </p>
                          ) : null}
                        </div>
                        <div className="certificate-code-actions">
                          {/* ------------ verify button CC---------- */}
                          <VerifyButton
                            onClick={() => {
                              handleVerifyAttorney(
                                values.couponcode_first,
                                setValues,
                                "CC"
                              );
                            }}
                            loading={loadingStates.isCCVerifying}
                            nonLoadingContent={"Verify"}
                          />
                          {/* ------------ associate Button [CC] ------------- */}
                          <VerifyButton
                            onClick={() => {
                              handleAssociateAttorney("CC");
                            }}
                            disabled={allowAssociate.CC}
                            loading={loadingStates.CCAssociating}
                            nonLoadingContent={"Associate CC"}
                          />
                        </div>
                      </div>
                      {/* ------------ Attorney Code [DE] ---------- */}
                      <div className="col-lg-6 certificate-code-column">
                        <div className=" input_wrap">
                          <label className="label-title" htmlFor="student-de-code">
                            DE Code{" "}
                            {values.activeCode &&
                              values.activeCode === "DE" &&
                              "(Active)"}
                          </label>
                          <input
                            id="student-de-code"
                            type="text"
                            className="form-control"
                            onChange={(e) => {
                              handleChange(e);
                              setattCodeValidation(false);
                              setAllowAssociate((prev) => ({
                                ...prev,
                                DE: false,
                              }));
                            }}
                            onBlur={handleBlur}
                            name="couponcode_second"
                            value={values.couponcode_second}
                          />
                          {/* {values.couponcode_first &&
                        values.attyemail &&
                        !values.attorneyCodeExist ? (
                          <p className="text-danger">
                            Attorney code no longer supported
                          </p>
                        ) : null} */}
                          {attCodeValidation === "DE" && (
                            <p className="text-danger">
                              Invalid Attorney Code{" "}
                            </p>
                          )}
                          {errors.couponcode_second &&
                          touched.couponcode_second ? (
                            <p className="text-danger">
                              {errors.couponcode_second}
                            </p>
                          ) : null}
                        </div>
                        {/* ------------ verify & associate button [DE] ---------- */}
                        <div className="certificate-code-actions">
                          <VerifyButton
                            onClick={() => {
                              handleVerifyAttorney(
                                values.couponcode_second,
                                setValues,
                                "DE"
                              );
                            }}
                            loading={loadingStates.isDEVerifying}
                            nonLoadingContent={"Verify"}
                          />
                          {/* ---------------- associate DE button */}
                          <VerifyButton
                            onClick={() => {
                              handleAssociateAttorney("DE");
                            }}
                            disabled={allowAssociate.DE}
                            loading={loadingStates.DEAssociating}
                            nonLoadingContent={"Associate DE"}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* ---------------------------------------------------------------------------------------------- */}

                  {secEmails && secEmails.length > 0 && (
                  <div className="row mt-40">
                      <div className="client-head">
                        <div className="row align-items-center">
                          <div className="col-lg-12">
                            <h1>Attorney Secondary Emails</h1>
                          </div>
                        </div>
                      </div>
                    <div className="row">
                      {secEmails.map((item, index) => (
                          <div
                            className="col-lg-4 d-flex align-items-start secondary-emails"
                            key={index}
                          >
                            <div className="input_wrap w-100">
                              <label className="label-title">
                                Email {index + 1}
                              </label>
                              <input
                                type="text"
                                readOnly
                                value={item.email}
                                className="form-control"
                              />
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                  )}
                  <div className="text-center student-edit-actions">
                    {/* <button className="btn_brnd-outline my-2 me-3">
                    Login as This User
                  </button> */}
                    <button
                      className="btn_brnd my-3"
                      type="submit"
                      disabled={
                        postLoading ||
                        generatingFirst ||
                        generatingFirstJointRetake ||
                        generatingSecond ||
                        generatingSecondJoint
                      }
                      onClick={() => {
                        // if (Object.keys(errors).length > 0) {
                        //   toast.error("Form validation failed");
                        // }
                      }}
                    >
                      {postLoading ? (
                        <ThreeDots
                          height="20"
                          width="60"
                          radius="9"
                          color="#4fa94d"
                          ariaLabel="three-dots-loading"
                          wrapperStyle={{
                            display: "block",
                          }}
                          wrapperClassName="spinner"
                          visible={true}
                        />
                      ) : (
                        "Update"
                      )}
                    </button>
                  </div>
                </form>
              </section>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default EditingClient;
